import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import LandingPage from "../apply-new-flow/pages/LandingPage";
import MobileVerificationPage from "../apply-new-flow/pages/MobileVerificationPage";
import LocationPage from "../apply-new-flow/pages/LocationPage";
import PanVerificationPage from "../apply-new-flow/pages/PanVerificationPage";
import AadhaarVerificationPage from "../apply-new-flow/pages/AadhaarVerificationPage";
import EmploymentPage from "../apply-new-flow/pages/EmploymentPage";
import ProcessingPage from "../apply-new-flow/pages/ProcessingPage";
import BankSelectionPage from "../apply-new-flow/pages/BankSelectionPage";
import BankAccountPage from "../apply-new-flow/pages/BankAccountPage";
import AAMobilePage from "../apply-new-flow/pages/AAMobilePage";
import AAOtpPage from "../apply-new-flow/pages/AAOtpPage";
import AccountSelectionPage from "../apply-new-flow/pages/AccountSelectionPage";
import ConsentPage from "../apply-new-flow/pages/ConsentPage";
import BankSuccessPage from "../apply-new-flow/pages/BankSuccessPage";
import ApprovedPage from "../apply-new-flow/pages/ApprovedPage";
import ReferenceDetailsPage from "../apply-new-flow/pages/ReferenceDetailsPage";
import RejectModal from "../apply-new-flow/pages/RejectModal";
import ReferenceReviewPage from "../apply-new-flow/pages/ReferenceReviewPage";
import SelfiePage from "../apply-new-flow/pages/SelfiePage";
import SelfieCapturePage from "../apply-new-flow/pages/SelfieCapturePage";
import LeadSubmissionPage from "../apply-new-flow/pages/LeadSubmittingPage";
import SelfieSuccessPage from "../apply-new-flow/pages/SelfieSuccessPage";
import SectionLetterPage from "../apply-new-flow/pages/SectionLetterPage";
import DisbursementProcessingPage from "../apply-new-flow/pages/DisbursementProcessingPage";
import LoanInProgressPage from "../apply-new-flow/pages/LoanInProgressPage";
import ProfilePage from "../apply-new-flow/pages/ProfilePage";
import PaymentHistoryPage from "../apply-new-flow/pages/PaymentHistoryPage";
import FwDropdown from "../apply-new-flow/components/FwDropdown";
import FwDayCalendar from "../apply-new-flow/components/FwDayCalendar";
import OfferPage from "../apply-new-flow/pages/OfferPage";
import AddBankDetailsPage from "../apply-new-flow/pages/AddBankDetailsPage";
import HoldPage from "../apply-new-flow/pages/HoldPage";
import EMandatePage from "../apply-new-flow/pages/EMandatePage";
import ActiveLoanHomePage from "../apply-new-flow/pages/ActiveLoanHomePage";
import RepaymentPage from "../apply-new-flow/pages/RepaymentPage";
import DemoPaymentPage from "../apply-new-flow/pages/DemoPaymentPage";
import PaymentSuccessPage from "../apply-new-flow/pages/PaymentSuccessPage";
import AACallbackPage from "../apply-new-flow/pages/AACallbackPage";
import MobileBreRejectPage from "../apply-new-flow/pages/MobileBreRejectPage";
import {
  PAN_REGEX,
  MOBILE_REGEX,
  OTP_RESEND_SECONDS,
  LOAN_PURPOSES,
  EMPLOYMENT_TYPES,
  SALARY_MODES,
  REFERENCE_RELATIONS,
  VERIFY_STEPS,
} from "../apply-new-flow/constants/applyFlowConstants";

import {
  validatePanAadhaarBank,
} from "../apply-new-flow/utils/applyFlowValidation";
import {
  normalizeEmailInput,
  validateEmail,
} from "../utils/emailValidation";
import { checkCustomerByPan } from "../utils/panCustomerCheck";
import { parseAadhaarVerifyResponse } from "../utils/aadhaarVerifyUtils";
import {
  getAadhaarNumberSecure,
  getAadhaarReferenceSecure,
  sanitizeAadhaarProfile,
  setAadhaarNumberSecure,
  setAadhaarReferenceSecure,
} from "../utils/applyFlowStorage";
import {
  backendStepForScreen,
  buildSessionFromStored,
  clearCustomerSession,
  fetchCustomerSession,
  getCustomerSession,
  mergeCustomerSession,
  pickFurthestScreen,
  pickResumeScreen,
  postCustomerSession,
  resolveResumeScreen,
  saveCustomerSession,
} from "../utils/applyFlowSession";
import { loanBackendUrl, loanBackendPostUrl, bankAcVerificationUrl,locationBreUrl ,creditAnalyticsUrl,  bureauMobileBreUrl,generateAccountAggregatorUrl,  checkAccountAggregatorStatus} from "../config/taskApi";
import {
  buildBankVerificationPayload,
  getBankVerificationBankingId,
  getBankVerificationMessage,
  isBankVerificationSuccess,
} from "../utils/bankAcVerification";
import { fetchCustomerProfile } from "../utils/profileCustomer";
import {
  buildLeadApplicationPayload,
  submitLeadApplication,
} from "../utils/leadApplication";
import {
  ALL_BANKS,
  BANK_ACCOUNTS,
  POPULAR_BANKS,
} from "./applyNewFlowBankData";
import indiaEmblem from "../assets/images/india-emblem.png";
import aadhaarLogoMark from "../assets/images/aadhaar-logo-mark.png";
import aadhaarLogoRight from "../assets/images/aadhaar-logo-right.png";
import OfferHeroArt from "./OfferHeroArt";
import FwSelfieCamera from "./FwSelfieCamera";
import FwProfileScreen from "./FwProfileScreen";
import FwPaymentHistoryScreen from "./FwPaymentHistoryScreen";
import "./ApplyNewFlow.css";


// const VERIFY_PAN_URL = "/loan_backend/verifyPan.php";
const VERIFY_PAN_URL ="https://fundswalla.in/Api/AutomationApi/verifyPan";
// const SEND_AADHAAR_OTP_URL = "/loan_backend/sendAadhaarOtp.php";
const SEND_AADHAAR_OTP_URL =
  "https://fundswalla.in/Api/AutomationApi/sendAadhaarOtp";
const VERIFY_AADHAAR_OTP_URL = "https://fundswalla.in/loan_backend/verifyAadhaarOtp.php";
// const SEND_OTP_URL = "/Api/TaskApi/sendOtp1";
const SEND_OTP_URL = "/Api/AutomationApi/sendOtp1";
// const VERIFY_OTP_URL = "/Api/TaskApi/verifyOtp";
const VERIFY_OTP_URL = "/Api/AutomationApi/verifyOtp";
const LOGIN_CUSTOMER_URL = loanBackendPostUrl("loginCustomerMobile.php");
const PROFILE_CUSTOMER_URL = loanBackendUrl("profileCustomer.php");
const LEAD_APPLICATION_URL = loanBackendPostUrl("leadApplication.php");
const BANK_AC_VERIFY_URL = bankAcVerificationUrl();
const LOCATION_STORAGE_KEY = "applyFlowLocation";
const SELFIE_STORAGE_KEY = "applyFlowSelfiePhoto";

const EMPTY_LOCATION = { latitude: "", longitude: "", coordinates: "" };

const readStoredLocation = () => {
  try {
    const raw =
      localStorage.getItem(LOCATION_STORAGE_KEY) ||
      sessionStorage.getItem(LOCATION_STORAGE_KEY);
    if (!raw) return EMPTY_LOCATION;
    const parsed = JSON.parse(raw);
    return {
      latitude: String(parsed.latitude || ""),
      longitude: String(parsed.longitude || ""),
      coordinates: String(parsed.coordinates || ""),
    };
  } catch {
    return EMPTY_LOCATION;
  }
};

const persistLocation = (coords) => {
  const serialized = JSON.stringify(coords);
  localStorage.setItem(LOCATION_STORAGE_KEY, serialized);
  sessionStorage.setItem(LOCATION_STORAGE_KEY, serialized);
};

const readStoredSelfie = () => {
  try {
    return sessionStorage.getItem(SELFIE_STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

const persistSelfie = (photo) => {
  try {
    if (photo && String(photo).startsWith("data:")) {
      sessionStorage.setItem(SELFIE_STORAGE_KEY, photo);
    }
  } catch {
  }
};

const parseStoredJson = (value, fallback = null) => {
  if (!value) return fallback;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const formatMobileDisplay = (mobile) => {
  const digits = String(mobile || "").replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return "+91";
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
};

const formatDob = (value) => {
  if (!value) return "—";
  const raw = String(value).trim();
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  return raw;
};

const formatCountdown = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((part) => String(part).padStart(2, "0"))
    .join(":");
};

const formatLoanAmount = (value) => {
  const amount = Number(String(value || "").replace(/\D/g, ""));
  if (!amount) return "₹25,000";
  return `₹${amount.toLocaleString("en-IN")}`;
};

const WEEK_DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const getMonthInfo = (offset = 0) => {
  const now = new Date();
  const date = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  return { year: date.getFullYear(), month: date.getMonth() };
};

const formatSalaryDate = (day, month, year) => {
  const dd = String(day).padStart(2, "0");
  const mm = String(month + 1).padStart(2, "0");
  const yy = String(year).slice(-2);
  return `${dd}${mm}${yy}`;
};

const formatSalaryDateDisplay = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  if (digits.length !== 6) return raw || "";
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 6)}`;
};

const isValidSalaryDate = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!/^\d{6}$/.test(digits)) return false;
  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const year = 2000 + Number(digits.slice(4, 6));
  if (month < 1 || month > 12 || day < 1) return false;
  const daysInMonth = new Date(year, month, 0).getDate();
  if (day > daysInMonth) return false;

  const selected = new Date(year, month - 1, day);
  selected.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const current = getMonthInfo(0);
  const next = getMonthInfo(1);
  const isCurrent = year === current.year && month === current.month + 1;
  const isNext = year === next.year && month === next.month + 1;
  if (!isCurrent && !isNext) return false;
  if (selected < today) return false;
  return true;
};

const ApplyNewFlow = () => {
  const navigate = useNavigate();
  const { pagename } = useParams()
  const [sessionBooting, setSessionBooting] = useState(true);
  const screen = pagename || "landing";
  const [sheet, setSheet] = useState(null);
  const [sheetVisible, setSheetVisible] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [mobile, setMobile] = useState("");
  const [consent, setConsent] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [otpSending, setOtpSending] = useState(false);

  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const otpRefs = useRef([]);

  const [locationError, setLocationError] = useState("");
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationCoords, setLocationCoords] = useState(readStoredLocation);
  const leadPayloadRef = useRef({});

  const [pan, setPan] = useState("");
  const [email, setEmail] = useState("");
  const [panError, setPanError] = useState("");
  const [panStatus, setPanStatus] = useState("");
  const [emailError, setEmailError] = useState("");
  const [checking, setChecking] = useState(false);
  const [panChecking, setPanChecking] = useState(false);
  const [panProfile, setPanProfile] = useState(null);
  const panCheckLockRef = useRef(false);
  const lastFetchedPanRef = useRef("");

  const [holdMessage, setHoldMessage] = useState("");
  const [employment, setEmployment] = useState({
    employer: "",
    salary: "",
    salaryDate: "",
    loanAmount: "",
    loanPurpose: "",
    employmentType: "",
    salaryMode: "",
  });
  const [employmentError, setEmploymentError] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [verifyStep, setVerifyStep] = useState(0);
  const [offerSeconds, setOfferSeconds] = useState(541);
  const [selectedBankId, setSelectedBankId] = useState("hdfc");
  const [bankSearch, setBankSearch] = useState("");
  const [aaMobile, setAaMobile] = useState("");
  const [aaMobileError, setAaMobileError] = useState("");
  const [aaOtpDigits, setAaOtpDigits] = useState(["", "", "", "", "", ""]);
  const [aaOtpError, setAaOtpError] = useState("");
  const [aaResendTimer, setAaResendTimer] = useState(0);
  const [selectedAccountId, setSelectedAccountId] = useState("acc1");
  const [bankAccounts, setBankAccounts] = useState(BANK_ACCOUNTS);
  const [addBankSource, setAddBankSource] = useState("offer");
  const aaOtpRefs = useRef([]);
  const [activeReferenceTab, setActiveReferenceTab] = useState(0);
  const [references, setReferences] = useState([
    { name: "", mobile: "", relation: "" },
    { name: "", mobile: "", relation: "" },
  ]);
  const [referenceError, setReferenceError] = useState("");
  const [selfieFaceReady, setSelfieFaceReady] = useState(false);
  const [selfieHint, setSelfieHint] = useState(
    "Position your face inside the frame and ensure that the circle is green."
  );
  const [selfieError, setSelfieError] = useState("");
  const [selfiePhoto, setSelfiePhoto] = useState(readStoredSelfie);
  const selfieCameraRef = useRef(null);
  const [paymentHistoryTab, setPaymentHistoryTab] = useState("transactions");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarError, setAadhaarError] = useState("");
  const [aadhaarStatus, setAadhaarStatus] = useState("");
  const [aadhaarProfile, setAadhaarProfile] = useState(null);
  const [aadhaarConsent, setAadhaarConsent] = useState(false);
  const [aadhaarSending, setAadhaarSending] = useState(false);
  const [aadhaarDigiLoading, setAadhaarDigiLoading] =useState(false);

const [aadhaarDigiError, setAadhaarDigiError] = useState("");
  const aadhaarCheckLockRef = useRef(false);
  const [aadhaarOtpDigits, setAadhaarOtpDigits] = useState(["", "", "", "", "", ""]);
  const [aadhaarOtpError, setAadhaarOtpError] = useState("");
  const [aadhaarOtpVerifying, setAadhaarOtpVerifying] = useState(false);
  const [aadhaarResendTimer, setAadhaarResendTimer] = useState(0);
  const aadhaarOtpRefs = useRef([]);
  const [disburseBank, setDisburseBank] = useState({
    bankName: "",
    holderName: "",
    accountNumber: "",
    ifsc: "",
  });
  const [disburseBankError, setDisburseBankError] = useState("");
  const [disburseBankSuccess, setDisburseBankSuccess] = useState("");
  const [disburseBankVerifying, setDisburseBankVerifying] = useState(false);
  const [customerBankingId, setCustomerBankingId] = useState("");
  const [customerLeadId, setCustomerLeadId] = useState("");
  const [customerStep, setCustomerStep] = useState(1);
  const [customerProfile, setCustomerProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);
  const [leadSubmitting, setLeadSubmitting] = useState(false);
  const [leadSubmitError, setLeadSubmitError] = useState("");
  const leadSubmittedRef = useRef(false);
const [repaymentData, setRepaymentData] = useState({
  paymentType: "",
  amount: 0,
  remainingAmount: 0,
});
  const restoreFromLoginSession = (login) => {
    if (!login) return "location";

    const fields = login.savedFields || {};
    const session = login.sessionData || {};
    const pick = (...keys) => {
      for (const key of keys) {
        const value = fields[key] ?? session[key];
        if (value !== undefined && value !== null && String(value).trim() !== "") {
          return value;
        }
      }
      return "";
    };

    const restoredMobile = String(login.customerMobile || pick("customer_mobile", "mobile") || "")
      .replace(/\D/g, "")
      .slice(-10);
    if (restoredMobile.length === 10) setMobile(restoredMobile);

    const restoredPan = String(pick("pan", "pan_number", "pancard") || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 10);
    if (restoredPan) setPan(restoredPan);

    const restoredEmail = String(pick("email", "email_personal", "email_id") || "");
    if (restoredEmail) setEmail(restoredEmail);

    const employer = String(pick("employer", "employer_name", "company_name") || "");
    const salary = String(pick("salary", "monthly_income", "monthlyIncome") || "");
    const salaryDate = String(pick("salary_date", "salaryDate") || "");
    const loanAmount = String(pick("loan_amount", "loanAmount") || "");
    const loanPurpose = String(pick("loan_purpose", "loanPurpose") || "");
    const employmentType = String(pick("employment_type", "employmentType") || "");
    const salaryMode = String(pick("salary_mode", "salaryMode") || "");
    if (
      employer ||
      salary ||
      salaryDate ||
      loanAmount ||
      loanPurpose ||
      employmentType ||
      salaryMode
    ) {
      setEmployment((prev) => ({
        ...prev,
        ...(employer ? { employer } : {}),
        ...(salary ? { salary } : {}),
        ...(salaryDate ? { salaryDate } : {}),
        ...(loanAmount ? { loanAmount } : {}),
        ...(loanPurpose ? { loanPurpose } : {}),
        ...(employmentType ? { employmentType } : {}),
        ...(salaryMode ? { salaryMode } : {}),
      }));
    }

    const aadhaar = String(pick("aadhaar_number", "aadhaar", "aadhar_no") || "").replace(/\D/g, "");
    if (aadhaar.length === 12) {
      setAadhaarNumber(aadhaar);
      setAadhaarNumberSecure(aadhaar);
    }

    const storedAadhaarProfile = parseStoredJson(pick("aadhaar_profile"));
    if (storedAadhaarProfile && typeof storedAadhaarProfile === "object") {
      setAadhaarProfile(storedAadhaarProfile);
      setAadhaarConsent(true);
    }

    const storedPanProfile = parseStoredJson(pick("pan_profile"));
    if (storedPanProfile && typeof storedPanProfile === "object") {
      setPanProfile(storedPanProfile);
    }

    const storedBank = parseStoredJson(pick("disburse_bank"));
    if (storedBank && typeof storedBank === "object") {
      setDisburseBank((prev) => ({ ...prev, ...storedBank }));
    }
    const bankingId = String(pick("cust_banking_id") || "");
    if (bankingId) setCustomerBankingId(bankingId);

    const storedRefs = parseStoredJson(pick("references"));
    if (Array.isArray(storedRefs) && storedRefs.length) {
      setReferences((prev) =>
        prev.map((item, index) => ({
          ...item,
          ...(storedRefs[index] || {}),
        }))
      );
    }

    const lat = String(pick("latitude") || "");
    const lng = String(pick("longitude") || "");
    const coordinates = String(pick("coordinates") || (lat && lng ? `${lat},${lng}` : ""));
    if (lat || lng || coordinates) {
      const next = { latitude: lat, longitude: lng, coordinates };
      setLocationCoords(next);
      persistLocation(next);
    }

    // if (login.leadId) setCustomerLeadId(String(login.leadId));
    // const step = Math.min(Math.max(Number(login.step) || 1, 1), 3);
    // const apiScreen = login.screen || resolveResumeScreen(step, login.savedFields);
    // const stored = getCustomerSession();
    const step = Math.min(Math.max(Number(login.step) || 1, 1), 3);
const apiScreen = login.screen || resolveResumeScreen(step, login.savedFields);

const stored = getCustomerSession() || {};

// Lead ID priority:
// 1. Login response
// 2. Login sessionData
// 3. Existing localStorage session
const restoredLeadId = String(
  login?.leadId ||
  login?.sessionData?.lead_id ||
  stored?.lead_id ||
  ""
).trim();

if (restoredLeadId) {
  setCustomerLeadId(restoredLeadId);
}
    const localLast = pickFurthestScreen(
      stored?.last_screen,
      fields.last_screen || login.sessionData?.last_screen
    );
    const targetScreen = pickFurthestScreen(localLast, apiScreen);
    setCustomerStep(step);
    saveCustomerSession({
      ...login.sessionData,
        ...(restoredLeadId ? { lead_id: restoredLeadId } : {}),
      step,
      last_screen: targetScreen,
      customer_mobile: restoredMobile || login.customerMobile,
      saved_fields: {
        ...(stored?.saved_fields || {}),
        ...(login.savedFields || {}),
        last_screen: targetScreen,
        ...(fields.aadhaar_verified === "1" ||
          fields.aadhaar_verified === true ||
          stored?.saved_fields?.aadhaar_verified === "1" ||
          aadhaarProfile
          ? { aadhaar_verified: "1" }
          : {}),
        ...(aadhaar || fields.aadhaar_number ? { aadhaar_number: aadhaar || fields.aadhaar_number } : {}),
      },
    });

    return targetScreen;
  };

  const buildProgressFields = (extra = {}) => ({
    pan: pan.trim().toUpperCase(),
    email: normalizeEmailInput(email),
    latitude: locationCoords.latitude,
    longitude: locationCoords.longitude,
    coordinates: locationCoords.coordinates,
    employer: employment.employer,
    monthly_income: employment.salary,
    salary_date: employment.salaryDate,
    loan_amount: employment.loanAmount,
    loan_purpose: employment.loanPurpose,
    employment_type: employment.employmentType,
    salary_mode: employment.salaryMode,
    ...extra,
  });

  const saveCustomerProgress = async (step, extraFields = {}) => {
    const customerMobile = String(mobile || getCustomerSession()?.customer_mobile || "")
      .replace(/\D/g, "")
      .slice(-10);
    if (customerMobile.length !== 10) return null;

    try {
      const login = await postCustomerSession(
        LOGIN_CUSTOMER_URL,
        customerMobile,
        step,
        buildProgressFields(extraFields)
      );
      if (login.ok) {
        restoreFromLoginSession(login);
      }
      return login;
    } catch {
      return null;
    }
  };

  const SAVE_ENQUIRY_URL = "https://fundswalla.in/loan_backend/saveEnquiry.php";

  const saveEnquiryProgress = async (step, extraFields = {}) => {
    const customerMobile = String(
      mobile || getCustomerSession()?.customer_mobile || ""
    )
      .replace(/\D/g, "")
      .slice(-10);

    if (customerMobile.length !== 10) {
      console.warn(
        "saveEnquiry skipped: invalid mobile",
        customerMobile
      );
      return null;
    }

    const payload = {
      Mobile: customerMobile,
      mobile: customerMobile,
      mobile_verified: extraFields.mobile_verified ?? 0,

      ...extraFields,

      step,
      source: "APPLY-NOW",
    };

    try {
      console.log("========== SAVE ENQUIRY ==========");
      console.log("STEP:", step);
      console.log("PAYLOAD:", payload);

      const response = await axios.post(
        SAVE_ENQUIRY_URL,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 20000,
        }
      );

      console.log(
        "SAVE ENQUIRY RESPONSE:",
        response.data
      );

      return response.data;
    } catch (error) {
      console.error(
        "SAVE ENQUIRY ERROR:",
        error?.response?.data || error?.message
      );

      return null;
    }
  };

  const loginCustomerByMobile = async (mobileValue) => {
    const customerMobile = String(mobileValue || "").replace(/\D/g, "").slice(-10);
    if (customerMobile.length !== 10) {
      return { ok: false, screen: "location" };
    }

    const login = await fetchCustomerSession(LOGIN_CUSTOMER_URL, customerMobile);
    if (!login.ok) {
      return { ok: false, screen: "location", message: login.message };
    }

    const nextScreen = restoreFromLoginSession(login);
    return { ok: true, screen: nextScreen, login };
  };



  useEffect(() => {
    const stored = getCustomerSession();
    const storedLogin = buildSessionFromStored(stored);
    if (!storedLogin) {
      setSessionBooting(false);
      return undefined;
    }
    // restoreFromLoginSession(storedLogin);
    // navigate('/apply-new/' + storedLogin.screen);
    // setSessionBooting(false);
    restoreFromLoginSession(storedLogin);

// if (screen !== "aaCallback") {
const params = new URLSearchParams(
  window.location.search
);

const isEMandateCallback =
  screen === "approved" &&
  (params.get("status") === "true" ||
    params.get("status") === "false");

// if (
//   screen !== "aaCallback" &&
//   !isEMandateCallback
// ) {

//   navigate('/apply-new/' + storedLogin.screen);
// }

if (
  screen !== "aaCallback" &&
  screen !== "aadhaarCallback" &&
  !isEMandateCallback
) {
  navigate('/apply-new/' + storedLogin.screen);
}

setSessionBooting(false);

    return undefined;
  }, []);


  useEffect(() => {
  const handleAACallbackMessage = (event) => {
    // Same localhost origin se hi message accept karna
    if (event.origin !== window.location.origin) {
      return;
    }

    if (event.data?.type !== "AA_COMPLETED") {
      return;
    }

    console.log("=================================");
    console.log("AA COMPLETION MESSAGE RECEIVED");
    console.log("=================================");

    console.log("AA MESSAGE:", event.data);

    // const leadId = event.data?.leadId || "";

    // console.log(
    //   "AA completed for Lead ID:",
    //   leadId
    // );
    const leadId = event.data?.leadId || "";

console.log(
  "AA completed for Lead ID:",
  leadId
);

if (leadId) {
  console.log(
    "========== NAVIGATING TAB 1 TO AA CALLBACK =========="
  );

  navigate(
    `/apply-new/aaCallback?lead_id=${encodeURIComponent(leadId)}`
  );
}

    // Abhi sirf test kar rahe hain.
    // Next screen baad mein yahan set karenge.
    //
    // navigate("/apply-new/approved");
  };

  window.addEventListener(
    "message",
    handleAACallbackMessage
  );

  return () => {
    window.removeEventListener(
      "message",
      handleAACallbackMessage
    );
  };
}, [navigate]);

useEffect(() => {
  // Backend DigiLocker completion ke baad
  // directly /apply-new/employment par redirect karega.

  if (screen !== "employment") {
    return;
  }

  // Original Tab 1 mein kuch nahi karna.
  // Sirf DigiLocker wale child Tab 2 ko handle karna hai.
  if (
    !window.opener ||
    window.opener === window
  ) {
    return;
  }

  console.log(
    "================================="
  );
  console.log(
    "AADHAAR DIGILOCKER COMPLETED"
  );
  console.log(
    "EMPLOYMENT PAGE OPENED IN TAB 2"
  );
  console.log(
    "================================="
  );

  try {
    // Tab 1 ko completion message bhejo
    window.opener.postMessage(
      {
        type: "AADHAAR_COMPLETED",
        status: "true",
      },
      window.location.origin
    );

    console.log(
      "AADHAAR COMPLETION SENT TO TAB 1"
    );

  } catch (error) {
    console.error(
      "AADHAAR POST MESSAGE ERROR:",
      error
    );

    return;
  }

  // Tab 2 close karo
  setTimeout(() => {
    window.close();
  }, 300);

}, [screen]);
useEffect(() => {
  const params = new URLSearchParams(
    window.location.search
  );

  const status = params.get("status");

  // Sirf eMandate callback tab
  if (
    status !== "true" &&
    status !== "false"
  ) {
    return;
  }

  // Agar ye original Tab 1 hai,
  // to kuch nahi karna.
  if (
    !window.opener ||
    window.opener === window
  ) {
    return;
  }

  console.log(
    "================================="
  );

  console.log(
    "E-MANDATE CALLBACK TAB"
  );

  console.log(
    "E-MANDATE STATUS:",
    status
  );

  try {
    window.opener.postMessage(
      {
        type: "EMANDATE_COMPLETED",
        status: status,
      },
      window.location.origin
    );

    console.log(
      "E-MANDATE RESULT SENT TO TAB 1"
    );
  } catch (error) {
    console.error(
      "E-MANDATE POST MESSAGE ERROR:",
      error
    );

    return;
  }

  // Tab 2 close
  setTimeout(() => {
    window.close();
  }, 200);
}, []);
useEffect(() => {
  const handleAadhaarMessage = (event) => {
    // Same origin only
    if (
      event.origin !== window.location.origin
    ) {
      return;
    }

    if (
      event.data?.type !== "AADHAAR_COMPLETED"
    ) {
      return;
    }

    const status =
      event.data?.status || "true";

    console.log(
      "================================="
    );
    console.log(
      "AADHAAR RESULT RECEIVED IN TAB 1"
    );
    console.log(
      "AADHAAR STATUS:",
      status
    );
    console.log(
      "================================="
    );

    // Yahan successful Aadhaar ke baad
    // tumhara next flow chalega

    // if (
    //   status === "true" ||
    //   status === "1" ||
    //   status === "success"
    // ) {
    //   navigate("/apply-new/employment");
    // }
    if (
  status === "true" ||
  status === "1" ||
  status === "success"
) {
  // PAN confirmation sheet close karo
  closeSheet();

  // DigiLocker loading/error state reset
  setAadhaarDigiLoading(false);
  setAadhaarDigiError("");

  // Tab 1 ko employment page par le jao
  navigate("/apply-new/employment");
}
  };

  window.addEventListener(
    "message",
    handleAadhaarMessage
  );

  return () => {
    window.removeEventListener(
      "message",
      handleAadhaarMessage
    );
  };
}, [navigate]);
useEffect(() => {
  const handleEMandateMessage = (event) => {
    // Same origin only
    if (event.origin !== window.location.origin) {
      return;
    }

    if (
      event.data?.type !== "EMANDATE_COMPLETED"
    ) {
      return;
    }

    const status = event.data?.status;

    console.log(
      "================================="
    );
    console.log(
      "E-MANDATE RESULT RECEIVED IN TAB 1"
    );
    console.log(
      "E-MANDATE STATUS:",
      status
    );
    console.log(
      "================================="
    );

    if (
      status !== "true" &&
      status !== "false"
    ) {
      return;
    }

    navigate(
      `/apply-new/approved?status=${status}`
    );
  };

  window.addEventListener(
    "message",
    handleEMandateMessage
  );

  return () => {
    window.removeEventListener(
      "message",
      handleEMandateMessage
    );
  };
}, [navigate]);
  useEffect(() => {
    if (sessionBooting || screen === "landing") return;

    const customerMobile = String(mobile || getCustomerSession()?.customer_mobile || "")
      .replace(/\D/g, "")
      .slice(-10);
    if (customerMobile.length !== 10) return;

    const step = backendStepForScreen(screen) || customerStep;
    mergeCustomerSession({
      customer_mobile: customerMobile,
      step,
      last_screen: screen,
      saved_fields: {
        ...(getCustomerSession()?.saved_fields || {}),
        pan: pan.trim().toUpperCase(),
        email: normalizeEmailInput(email),
        latitude: locationCoords.latitude,
        longitude: locationCoords.longitude,
        coordinates: locationCoords.coordinates,
        employer: employment.employer,
        monthly_income: employment.salary,
        salary_date: employment.salaryDate,
        loan_amount: employment.loanAmount,
        loan_purpose: employment.loanPurpose,
        employment_type: employment.employmentType,
        salary_mode: employment.salaryMode,
        ...(aadhaarNumber ? { aadhaar_number: aadhaarNumber } : {}),
        ...(aadhaarProfile
          ? { aadhaar_verified: "1", aadhaar_profile: aadhaarProfile }
          : {}),
        ...(panProfile ? { pan_profile: panProfile } : {}),
        disburse_bank: disburseBank,
        ...(customerBankingId ? { cust_banking_id: customerBankingId } : {}),
        references,
        last_screen: screen,
      },
    });
    if (step) setCustomerStep(step);
  }, [
    screen,
    sessionBooting,
    mobile,
    customerStep,
    aadhaarNumber,
    aadhaarProfile,
    pan,
    email,
    locationCoords,
    employment,
    panProfile,
    disburseBank,
    customerBankingId,
    references,
  ]);

  useEffect(() => {
    if (screen !== "profile") return undefined;

    const stored = getCustomerSession() || {};
    const fields = stored.saved_fields || {};
    const customerMobile = String(
      mobile || stored.customer_mobile || fields.customer_mobile || ""
    )
      .replace(/\D/g, "")
      .slice(-10);

    const storedPan = parseStoredJson(fields.pan_profile);
    const storedAadhaar = parseStoredJson(fields.aadhaar_profile);
    const localName =
      panProfile?.name ||
      storedPan?.name ||
      aadhaarProfile?.name ||
      storedAadhaar?.name ||
      "";
    const localEmail = email || fields.email || fields.email_personal || "";
    const localAvatar = selfiePhoto || readStoredSelfie() || "";

    if (localName || localEmail || customerMobile) {
      setCustomerProfile((prev) => ({
        ok: true,
        name: prev?.name || localName,
        email: prev?.email || localEmail,
        mobile: prev?.mobile || customerMobile,
        avatarUrl: prev?.avatarUrl || localAvatar,
        raw: prev?.raw || {},
      }));
    }

    if (customerMobile.length !== 10) {
      setProfileLoading(false);
      return undefined;
    }

    let cancelled = false;
    setProfileLoading(true);

    fetchCustomerProfile(PROFILE_CUSTOMER_URL, customerMobile)
      .then((profile) => {
        if (cancelled || !profile.ok) return;
        setCustomerProfile((prev) => ({
          ...prev,
          ...profile,
          name: profile.name || prev?.name || localName,
          email: profile.email || prev?.email || localEmail,
          mobile: profile.mobile || prev?.mobile || customerMobile,
          avatarUrl: localAvatar || profile.avatarUrl || prev?.avatarUrl || "",
        }));
        if (profile.email) setEmail(profile.email);
        if (profile.mobile) setMobile(profile.mobile);
      })
      .catch(() => { })
      .finally(() => {
        if (!cancelled) setProfileLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [screen, mobile]);

  useEffect(() => {
    document.body.classList.add("fw-apply-open");
    return () => document.body.classList.remove("fw-apply-open");
  }, []);

  useEffect(() => {
    if (!sheet) {
      setSheetVisible(false);
      return undefined;
    }
    const id = requestAnimationFrame(() => setSheetVisible(true));
    return () => cancelAnimationFrame(id);
  }, [sheet]);

  useEffect(() => {
    if (resendTimer <= 0) return undefined;
    const timer = setInterval(() => {
      setResendTimer((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [resendTimer]);

  useEffect(() => {
    if (
      screen !== "employment" &&
      screen !== "referenceDetails" &&
      screen !== "addBankDetails"
    ) {
      setOpenDropdown(null);
    }
  }, [screen]);

  useEffect(() => {
    if (screen !== "processing") {
      setVerifyStep(0);
      return undefined;
    }

    const stepTimer = setInterval(() => {
      setVerifyStep((prev) => (prev + 1) % VERIFY_STEPS.length);
    }, 1000);

    return () => {
      clearInterval(stepTimer);
    };
  }, [screen]);

  useEffect(() => {
    if (screen !== "offer") {
      setOfferSeconds(541);
      return undefined;
    }

    const timer = setInterval(() => {
      setOfferSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [screen]);

  useEffect(() => {
    if (aaResendTimer <= 0) return undefined;
    const timer = setInterval(() => {
      setAaResendTimer((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [aaResendTimer]);

  useEffect(() => {
    if (aadhaarResendTimer <= 0) return undefined;
    const timer = setInterval(() => {
      setAadhaarResendTimer((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [aadhaarResendTimer]);

  const getBank = (bankId) =>
    ALL_BANKS.find((bank) => bank.id === bankId) || POPULAR_BANKS[1];

  const filteredBanks = ALL_BANKS.filter((bank) =>
    bank.name.toLowerCase().includes(bankSearch.trim().toLowerCase())
  );

  const openAaOtpSheet = () => {
    if (!MOBILE_REGEX.test(aaMobile)) {
      setAaMobileError("Enter a valid 10-digit mobile number");
      return;
    }
    setAaMobileError("");
    setAaOtpDigits(["", "", "", "", "", ""]);
    setAaOtpError("");
    setAaResendTimer(OTP_RESEND_SECONDS);
    openSheet("aaOtp");
  };

  const verifyAaOtp = () => {
    const value = aaOtpDigits.join("");
    if (value.length !== 6) {
      setAaOtpError("Enter the 6-digit OTP");
      return;
    }
    closeSheet();
    setTimeout(() => navigate("/apply-new/aaAccount"), 280);
  };

  const handleAaOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    setAaOtpDigits((prev) => {
      const next = [...prev];
      next[index] = digit;
      return next;
    });
    setAaOtpError("");
    if (digit && index < 5) aaOtpRefs.current[index + 1]?.focus();
  };

  const handleAaOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && !aaOtpDigits[index] && index > 0) {
      aaOtpRefs.current[index - 1]?.focus();
    }
  };

  const updateReference = (index, field, value) => {
    setReferences((prev) => {
      const next = [...prev];

      next[index] = {
        ...next[index],
        [field]: value,
      };
      if (
        field === "relation" &&
        index === 1 &&
        value &&
        value === next[0]?.relation
      ) {
        setReferenceError(
          "Reference 2 relation cannot be same as Reference 1"
        );
      } else {
        setReferenceError("");
      }

      return next;
    });
  };
  const normalizeRefName = (name) =>
    String(name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const getApplicantMobile = () =>
    String(mobile || getCustomerSession()?.customer_mobile || "")
      .replace(/\D/g, "")
      .slice(-10);

  const validateReference = (ref) => {
    if (!ref.name.trim()) return "Enter reference name";
    if (!MOBILE_REGEX.test(ref.mobile)) return "Enter a valid 10-digit mobile number";
    if (!ref.relation) return "Select relation";
    return "";
  };

  const getReferenceUniquenessError = (refs, index) => {
    const current = refs[index] || {};
    const other = refs[index === 0 ? 1 : 0] || {};
    const currentMobile = String(current.mobile || "").replace(/\D/g, "").slice(-10);
    const otherMobile = String(other.mobile || "").replace(/\D/g, "").slice(-10);
    const applicantMobile = getApplicantMobile();

    if (currentMobile.length === 10 && currentMobile === applicantMobile) {
      return "Reference mobile cannot be the same as your mobile number";
    }
    if (
      currentMobile.length === 10 &&
      otherMobile.length === 10 &&
      currentMobile === otherMobile
    ) {
      return "Both references must have different mobile numbers";
    }

    const currentName = normalizeRefName(current.name);
    const otherName = normalizeRefName(other.name);
    if (currentName && otherName && currentName === otherName) {
      return "Both references must have different names";
    }

    return "";
  };

  const proceedReference = async () => {
    const currentError = validateReference(references[activeReferenceTab]);
    if (currentError) {
      setReferenceError(currentError);
      return;
    }

    const uniquenessError = getReferenceUniquenessError(
      references,
      activeReferenceTab
    );
    if (uniquenessError) {
      setReferenceError(uniquenessError);
      return;
    }

    if (activeReferenceTab === 0) {
      setActiveReferenceTab(1);
      setReferenceError("");
      return;
    }

    const firstError = validateReference(references[0]);
    if (firstError) {
      setActiveReferenceTab(0);
      setReferenceError(firstError);
      return;
    }

    const firstUniqueError = getReferenceUniquenessError(references, 0);
    if (firstUniqueError) {
      setActiveReferenceTab(0);
      setReferenceError(firstUniqueError);
      return;
    }

    setReferenceError("");
    await saveEnquiryProgress("reference_completed", {
      mobile_verified: 1,

      reference1_name: references[0].name,
      reference1_mobile: references[0].mobile,
      reference1_relation: references[0].relation,

      reference2_name: references[1].name,
      reference2_mobile: references[1].mobile,
      reference2_relation: references[1].relation,
    });

    navigate("/apply-new/referenceReview");
  };

  const confirmReferences = () => {
    const firstError = validateReference(references[0]);

    if (firstError) {
      setActiveReferenceTab(0);
      setReferenceError(firstError);
      navigate("/apply-new/referenceDetails");
      return;
    }

    const secondError = validateReference(references[1]);

    if (secondError) {
      setActiveReferenceTab(1);
      setReferenceError(secondError);
      navigate("/apply-new/referenceDetails");
      return;
    }

    const uniqueError =
      getReferenceUniquenessError(references, 0) ||
      getReferenceUniquenessError(references, 1);

    if (uniqueError) {
      setActiveReferenceTab(1);
      setReferenceError(uniqueError);
      navigate("/apply-new/referenceDetails");
      return;
    }
    setAddBankSource("referenceReview");

    setDisburseBankError("");
    setDisburseBankSuccess("");

    setDisburseBank({
      bankName: getBank(selectedBankId).name,
      holderName: panProfile?.name || "",
      accountNumber: "",
      ifsc: "",
    });

    navigate("/apply-new/addBankDetails");
  };
  const formatAadhaarDisplay = (digits) =>
    String(digits || "")
      .replace(/\D/g, "")
      .slice(0, 12)
      .replace(/(\d{4})(?=\d)/g, "$1 ")
      .trim();

  const getAadhaarApiMessage = (data) =>
    data?.message || data?.responseMessage || data?.error || "";

  const mapAadhaarProfile = (profile, number) => {
    const safe = sanitizeAadhaarProfile(profile) || {};
    const name =
      safe.name ||
      safe.fullName ||
      [safe.firstName, safe.middleName, safe.lastName].filter(Boolean).join(" ") ||
      "—";

    return {
      name,

      firstName: safe.firstName || safe.first_name || "",
      middleName: safe.middleName || safe.middle_name || "",
      lastName: safe.lastName || safe.last_name || "",

      dob: formatDob(safe.dob || safe.dateOfBirth || safe.date_of_birth),
      dobRaw: safe.dob || safe.dateOfBirth || safe.date_of_birth || "",
      gender: safe.gender || safe.sex || "",
      // address: safe.address || safe.locality||"",
      address: [
  safe.house,
  safe.street,
  safe.locality,
  safe.postOfficeName,
  safe.vtcName,
  safe.landmark,
  // safe.subDistrict,
  // safe.pincode,
  // safe.district,
  // safe.state,
]
  .map((value) => String(value || "").trim())
  .filter(Boolean)
  .join(", "),
      aadhaar: String(number || "").replace(/\D/g, "").slice(0, 12),
      raw: safe,
    };
  };

  // const sendAadhaarOtp = async (rawAadhaar, options = {}) => {
  //   if (rawAadhaar && typeof rawAadhaar === "object") {
  //     rawAadhaar = undefined;
  //   }
  //   const { requireConsent = true, openOtpSheet = true } = options;
  //   const number = String(
  //     rawAadhaar || getAadhaarNumberSecure() || aadhaarNumber
  //   )
  //     .replace(/\D/g, "")
  //     .slice(0, 12);
  //   const showOnOtpSheet = openOtpSheet || sheet === "aadhaarOtp";
  //   const setSendError = (msg) => {
  //     if (showOnOtpSheet) {
  //       setAadhaarOtpError(msg);
  //       return;
  //     }
  //     setAadhaarError(msg);
  //     setAadhaarStatus("");
  //   };

  //   if (!/^\d{12}$/.test(number)) {
  //     setSendError("Enter a valid 12-digit Aadhaar number");
  //     return;
  //   }
  //   if (requireConsent && !aadhaarConsent) {
  //     setAadhaarError("Please accept Aadhaar verification consent");
  //     setAadhaarStatus("");
  //     return;
  //   }
  //   if (aadhaarCheckLockRef.current) return;

  //   aadhaarCheckLockRef.current = true;
  //   setAadhaarSending(true);
  //   setAadhaarError("");
  //   setAadhaarStatus("");
  //   setAadhaarOtpError("");

  //   try {
  //     const res = await axios.post(
  //       SEND_AADHAAR_OTP_URL,
  //       { aadhaar_number: number },
  //       { headers: { "Content-Type": "application/json" }, timeout: 45000 }
  //     );

  //     const responseData = res.data || {};
  //     const { success, responseCode, referenceId } = responseData;
  //     const apiMessage = getAadhaarApiMessage(responseData);

  //     if (success === false) {
  //       setSendError(apiMessage || "Unable to send Aadhaar OTP. Please try again.");
  //       return;
  //     }

  //     if (
  //       responseData.responseMessage === "Aadhar does not exist" ||
  //       responseCode === "EAE168"
  //     ) {
  //       setSendError("Invalid Aadhaar number.");
  //       return;
  //     }

  //     const isOtpSent =
  //       success === true ||
  //       referenceId ||
  //       String(apiMessage).toLowerCase().includes("otp");

  //     if (!isOtpSent) {
  //       setSendError(apiMessage || "Unable to send Aadhaar OTP. Please try again.");
  //       return;
  //     }

  //     setAadhaarNumberSecure(number);
  //     setAadhaarReferenceSecure(referenceId || getAadhaarReferenceSecure() || "");
  //     setAadhaarOtpDigits(["", "", "", "", "", ""]);
  //     await saveEnquiryProgress("aadhaar_otp_sent", {
  //       mobile_verified: 1,

  //       aadhaar_number: number,
  //       aadhaar_reference_id:
  //         referenceId || getAadhaarReferenceSecure() || "",

  //       aadhaar_verified: 0,
  //     });

  //     const waitMatch = String(apiMessage).match(/(\d+)\s*(second|sec)/i);
  //     const waitSeconds = waitMatch ? Number(waitMatch[1]) : OTP_RESEND_SECONDS;
  //     setAadhaarResendTimer(
  //       Number.isFinite(waitSeconds) && waitSeconds > 0
  //         ? waitSeconds
  //         : OTP_RESEND_SECONDS
  //     );

  //     if (openOtpSheet) {
  //       setAadhaarStatus(apiMessage || "OTP sent successfully.");
  //       if (showOnOtpSheet && sheet === "aadhaarOtp") {
  //         setAadhaarOtpError("");
  //       }
  //       openSheet("aadhaarOtp");
  //       setTimeout(() => aadhaarOtpRefs.current[0]?.focus(), 320);
  //       return;
  //     }

  //     setAadhaarStatus(
  //       apiMessage || "Aadhaar verified. Accept consent and click Proceed."
  //     );
  //   } catch (err) {
  //     setSendError(
  //       getAadhaarApiMessage(err?.response?.data) ||
  //       "OTP failed. Please try again."
  //     );
  //   } finally {
  //     aadhaarCheckLockRef.current = false;
  //     setAadhaarSending(false);
  //   }
  // };

const sendAadhaarOtp = async (rawAadhaar, options = {}) => {
  if (rawAadhaar && typeof rawAadhaar === "object") {
    rawAadhaar = undefined;
  }

  const {
    requireConsent = true,
    openOtpSheet = true,
  } = options;

  const number = String(
    rawAadhaar ||
    getAadhaarNumberSecure() ||
    aadhaarNumber
  )
    .replace(/\D/g, "")
    .slice(0, 12);

  const showOnOtpSheet =
    openOtpSheet || sheet === "aadhaarOtp";

  const setSendError = (msg) => {
    if (showOnOtpSheet) {
      setAadhaarOtpError(msg);
      return;
    }

    setAadhaarError(msg);
    setAadhaarStatus("");
  };

  // ================================
  // AADHAAR VALIDATION
  // ================================
  if (!/^\d{12}$/.test(number)) {
    setSendError(
      "Enter a valid 12-digit Aadhaar number"
    );
    return;
  }

  if (requireConsent && !aadhaarConsent) {
    setAadhaarError(
      "Please accept Aadhaar verification consent"
    );
    setAadhaarStatus("");
    return;
  }

  if (aadhaarCheckLockRef.current) return;

  aadhaarCheckLockRef.current = true;
  setAadhaarSending(true);
  setAadhaarError("");
  setAadhaarStatus("");
  setAadhaarOtpError("");

  try {
    // ================================
    // LEAD ID FROM SESSION
    // ================================
    const stored = getCustomerSession() || {};
    const saved = stored?.saved_fields || {};

    const leadId = String(
      stored?.lead_id ||
      saved?.lead_id ||
      customerLeadId ||
      ""
    ).trim();

    if (!leadId) {
      setSendError("Lead ID is missing");
      return;
    }

    console.log(
      "========== SEND AADHAAR OTP =========="
    );

    console.log("LEAD ID:", leadId);
    console.log("AADHAAR:", number);

    // ================================
    // NEW API
    // ================================
    const res = await axios.post(
      SEND_AADHAAR_OTP_URL,
      {
        lead_id: leadId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        timeout: 45000,
        validateStatus: () => true,
      }
    );

    console.log(
      "SEND AADHAAR OTP RESPONSE:",
      res.data
    );

    const responseData = res.data || {};

    // ================================
    // ERROR RESPONSE
    // ================================
    if (
      res.status < 200 ||
      res.status >= 300 ||
      responseData?.status === false
    ) {
      setSendError(
        responseData?.message ||
        responseData?.msg ||
        responseData?.err ||
        "Unable to start Aadhaar verification."
      );
      return;
    }

    // ================================
    // SUCCESS
    // ================================
    const kycUrl =
      responseData?.data?.kycUrl || "";

    const redirectionUrl =
      responseData?.data?.redirectionUrl || "";

    console.log(
      "DIGITAP KYC URL:",
      kycUrl
    );

    console.log(
      "AADHAAR REDIRECTION URL:",
      redirectionUrl
    );

    /*
     * New API is generating DigiLocker URL,
     * so OTP/referenceId flow is not handled here.
     */

    if (!kycUrl) {
      setSendError(
        responseData?.message ||
        "DigiLocker URL was not received."
      );
      return;
    }

    // ================================
    // STORE LEAD / KYC INFO
    // ================================
    setAadhaarNumberSecure(number);

    await saveEnquiryProgress(
      "aadhaar_kyc_started",
      {
        mobile_verified: 1,
        aadhaar_number: number,
        aadhaar_verified: 0,
        aadhaar_lead_id: leadId,
        aadhaar_kyc_url: kycUrl,
        aadhaar_redirection_url:
          redirectionUrl,
      }
    );

    // ================================
    // OPEN DIGILOCKER
    // ================================
    if (openOtpSheet) {
      window.open(
        kycUrl,
        "_blank"
      );
      return;
    }

    setAadhaarStatus(
      responseData?.message ||
      "Aadhaar verification started successfully."
    );

  } catch (err) {
    console.error(
      "SEND AADHAAR OTP ERROR:",
      err
    );

    setSendError(
      err?.response?.data?.message ||
      err?.response?.data?.msg ||
      err?.response?.data?.err ||
      err?.message ||
      "Unable to start Aadhaar verification."
    );

  } finally {
    aadhaarCheckLockRef.current = false;
    setAadhaarSending(false);
  }
};

  const resendAadhaarOtp = () => {
    sendAadhaarOtp(getAadhaarNumberSecure() || aadhaarNumber, {
      requireConsent: false,
      openOtpSheet: true,
    });
  };
  const validateAadhaarAgainstPan = (aadhaarValue) => {
    const aadhaar = String(aadhaarValue || "")
      .replace(/\D/g, "")
      .slice(0, 12);

    const maskedAadhaar = String(
      panProfile?.maskedAadhaarNumber || ""
    ).trim();

    if (!/^\d{12}$/.test(aadhaar)) {
      return {
        valid: false,
        message: "",
      };
    }


    const first2Match = maskedAadhaar.match(/^(\d{2})X+(\d{2})$/i);

    if (first2Match) {
      const panFirst2 = first2Match[1];
      const panLast2 = first2Match[2];

      const aadhaarFirst2 = aadhaar.slice(0, 2);
      const aadhaarLast2 = aadhaar.slice(-2);

      const isMatch =
        panFirst2 === aadhaarFirst2 &&
        panLast2 === aadhaarLast2;

      return {
        valid: isMatch,
        message: isMatch
          ? "Aadhaar details matched."
          : "Wrong Aadhaar number. Please enter the Aadhaar linked with your PAN.",
      };
    }

    /*
     * CASE 2:
     * PAN response = XXXXXXXX6395
     */
    const last4Match = maskedAadhaar.match(/^X+(\d{4})$/i);

    if (last4Match) {
      const panLast4 = last4Match[1];
      const aadhaarLast4 = aadhaar.slice(-4);

      const isMatch = panLast4 === aadhaarLast4;

      return {
        valid: isMatch,
        message: isMatch
          ? "Aadhaar details matched."
          : "Wrong Aadhaar number. Please enter the Aadhaar linked with your PAN.",
      };
    }

    return {
      valid: false,
      message: "PAN linked Aadhaar details are not available.",
    };
  };

  const checkAadhaarOnEnter = (rawAadhaar) => {
    const number = String(rawAadhaar || "")
      .replace(/\D/g, "")
      .slice(0, 12);

    if (number.length !== 12) {
      setAadhaarError("");
      setAadhaarStatus("");
      return;
    }

    const validation = validateAadhaarAgainstPan(number);

    if (!validation.valid) {
      setAadhaarError(validation.message);
      setAadhaarStatus("");
      return;
    }

    setAadhaarError("");
    setAadhaarStatus("Aadhaar details matched with PAN.");
  };
  //

  const openAadhaarOtpSheet = () => {
    setAadhaarOtpDigits(["", "", "", "", "", ""]);
    openSheet("aadhaarOtp");
    setTimeout(() => aadhaarOtpRefs.current[0]?.focus(), 320);
  };
//is code ko comment is liye kiye hai kyo ki abhi thir part adhar ka api kam nahi kar raha hai is loye ye 
//ye error aa raai is liy isko buypass kar de rahe hai isk acode nivchw hai commnet ke niche jab wo chale ga to 
//niche wale ko uncommnet kar ke uske badh wwale ko haa den ge 
  const verifyAadhaarOtp = async () => {
    
    const otpValue = aadhaarOtpDigits.join("");
    if (otpValue.length !== 6) {
      setAadhaarOtpError("Enter the 6-digit OTP");
      return;
    }

    setAadhaarOtpVerifying(true);
    setAadhaarOtpError("");

    try {
      const res = await axios.post(
        VERIFY_AADHAAR_OTP_URL,
        {
          aadhaar_number: getAadhaarNumberSecure() || aadhaarNumber,
          otp: otpValue,
          referenceId: getAadhaarReferenceSecure(),
        },
        { timeout: 45000 }
      );

      const parsed = parseAadhaarVerifyResponse(res.data);
      const isSuccess =
        parsed.responseCode === "SRC001" &&
        parsed.profile &&
        Object.keys(parsed.profile).length > 0;

      const responseMessage = String(parsed.responseMessage || "").toLowerCase();
      const isFailure =
        parsed.responseCode === "EAE168" ||
        responseMessage.includes("invalid") ||
        responseMessage.includes("incorrect") ||
        responseMessage.includes("failed");

      if (isSuccess) {
        const mapped = mapAadhaarProfile(
          parsed.profile,
          getAadhaarNumberSecure() || aadhaarNumber
        );
        console.log("========== AADHAAR PROFILE SET ==========");
        console.log("AADHAAR FULL OBJECT:", mapped);
        setAadhaarProfile(mapped);
        setAadhaarConsent(true);
        setAadhaarError("");
        mergeCustomerSession({
          saved_fields: {
            ...(getCustomerSession()?.saved_fields || {}),
            aadhaar_verified: "1",
            aadhaar_number: mapped.aadhaar,
            aadhaar_profile: mapped,
            aadhaar_dob: mapped.dobRaw || mapped.dob,
            aadhaar_gender: mapped.gender,
          },
        });

        await saveEnquiryProgress("aadhaar_verified", {
          mobile_verified: 1,

          aadhaar_verified: 1,
          aadhaar_number: mapped.aadhaar,

          aadhaar_name: mapped.name,
          aadhaar_first_name: mapped.firstName,
          aadhaar_middle_name: mapped.middleName,
          aadhaar_last_name: mapped.lastName,

          aadhaar_dob: mapped.dobRaw || mapped.dob,
          aadhaar_gender: mapped.gender,
          aadhaar_address: mapped.address,
        });

        // closeSheet();
        // return;
        closeSheet();

setTimeout(() => {
  navigate("/apply-new/employment");
}, 280);

return;
      }

      const errorMsg =
        res.data?.data?.responseMessage ||
        res.data?.message ||
        res.data?.error ||
        parsed.responseMessage ||
        (isFailure
          ? "Incorrect OTP. Please try again."
          : "OTP verification failed. Please try again.");
      setAadhaarOtpError(errorMsg);
    } catch (err) {
      setAadhaarOtpError(
        "OTP verification failed. Please check your internet connection and try again."
      );
    } finally {
      setAadhaarOtpVerifying(false);
    }
  };
// ============================================================
// TEMPORARY: Aadhaar DEV bypass
// API working hone ke baad isko false kar dena
// ============================================================
// const AADHAAR_DEV_BYPASS = true;

// const verifyAadhaarOtp = async () => {

//   const otpValue = aadhaarOtpDigits.join("");

//   if (otpValue.length !== 6) {
//     setAadhaarOtpError("Enter the 6-digit OTP");
//     return;
//   }

//   setAadhaarOtpVerifying(true);
//   setAadhaarOtpError("");

//   // ============================================================
//   // TEMPORARY DEV BYPASS
//   // ============================================================
//   if (AADHAAR_DEV_BYPASS) {

//     console.log("⚠️ AADHAAR DEV BYPASS ACTIVE");

//     const currentAadhaarNumber =
//       getAadhaarNumberSecure() || aadhaarNumber;

//     // Temporary test Aadhaar profile
//    const mockProfile = {
//   name: "Test Customer",
//   firstName: "Test",
//   middleName: "",
//   lastName: "Customer",
//   dob: "01/01/1995",
//   dobRaw: "1995-01-01",
//   gender: "MALE",
//   address: "Test Address",

//   aadhaar: currentAadhaarNumber,

//   city: "Noida",
//   state: "Uttar Pradesh",
//   pincode: "201301",

//   raw: {
//     mock: true,
//     source: "DEV_BYPASS",

//     district: "Noida",
//     state: "Uttar Pradesh",
//     pincode: "201301",
//   },
// };

//     console.log(
//       "⚠️ MOCK AADHAAR PROFILE:",
//       mockProfile
//     );

//     // Set Aadhaar profile
//     setAadhaarProfile(mockProfile);
//     setAadhaarConsent(true);
//     setAadhaarError("");
//     setAadhaarOtpError("");

//     // Save customer session
//   mergeCustomerSession({
//   saved_fields: {
//     ...(getCustomerSession()?.saved_fields || {}),

//     aadhaar_verified: "1",
//     aadhaar_number: mockProfile.aadhaar,
//     aadhaar_profile: mockProfile,

//     aadhaar_dob: mockProfile.dobRaw,
//     aadhaar_gender: mockProfile.gender,

//     // ADD THESE
//     city: mockProfile.city,
//     state: mockProfile.state,
//     pincode: mockProfile.pincode,
//   },
// });

//     // Save enquiry progress
//     await saveEnquiryProgress("aadhaar_verified", {

//       mobile_verified: 1,

//       aadhaar_verified: 1,

//       aadhaar_number: mockProfile.aadhaar,

//       aadhaar_name: mockProfile.name,
//       aadhaar_first_name: mockProfile.firstName,
//       aadhaar_middle_name: mockProfile.middleName,
//       aadhaar_last_name: mockProfile.lastName,

//       aadhaar_dob: mockProfile.dobRaw,
//       aadhaar_gender: mockProfile.gender,
//       aadhaar_address: mockProfile.address,

//       // Clearly identify this as testing
//       verification_mode: "DEV_BYPASS",
//     });

//     console.log(
//       "✅ Aadhaar DEV verification successful"
//     );

//     closeSheet();

//     setAadhaarOtpVerifying(false);

//     return;
//   }

//   // ============================================================
//   // REAL AADHAAR OTP VERIFICATION
//   // ============================================================

//   try {

//     const res = await axios.post(
//       VERIFY_AADHAAR_OTP_URL,
//       {
//         aadhaar_number:
//           getAadhaarNumberSecure() || aadhaarNumber,

//         otp: otpValue,

//         referenceId:
//           getAadhaarReferenceSecure(),
//       },
//       {
//         timeout: 45000,
//       }
//     );

//     const parsed = parseAadhaarVerifyResponse(
//       res.data
//     );

//     const isSuccess =
//       parsed.responseCode === "SRC001" &&
//       parsed.profile &&
//       Object.keys(parsed.profile).length > 0;

//     const responseMessage =
//       String(
//         parsed.responseMessage || ""
//       ).toLowerCase();

//     const isFailure =
//       parsed.responseCode === "EAE168" ||
//       responseMessage.includes("invalid") ||
//       responseMessage.includes("incorrect") ||
//       responseMessage.includes("failed");

//     // ==========================================================
//     // REAL API SUCCESS
//     // ==========================================================

//     if (isSuccess) {

//       const mapped = mapAadhaarProfile(
//         parsed.profile,
//         getAadhaarNumberSecure() || aadhaarNumber
//       );

//       console.log(
//         "========== AADHAAR PROFILE SET =========="
//       );

//       console.log(
//         "AADHAAR FULL OBJECT:",
//         mapped
//       );

//       setAadhaarProfile(mapped);
//       setAadhaarConsent(true);
//       setAadhaarError("");

//       // Save customer session
//       mergeCustomerSession({
//         saved_fields: {
//           ...(getCustomerSession()?.saved_fields || {}),

//           aadhaar_verified: "1",
//           aadhaar_number: mapped.aadhaar,
//           aadhaar_profile: mapped,
//           aadhaar_dob:
//             mapped.dobRaw || mapped.dob,
//           aadhaar_gender: mapped.gender,
//         },
//       });

//       // Save enquiry progress
//       await saveEnquiryProgress(
//         "aadhaar_verified",
//         {
//           mobile_verified: 1,

//           aadhaar_verified: 1,

//           aadhaar_number: mapped.aadhaar,

//           aadhaar_name: mapped.name,
//           aadhaar_first_name: mapped.firstName,
//           aadhaar_middle_name: mapped.middleName,
//           aadhaar_last_name: mapped.lastName,

//           aadhaar_dob:
//             mapped.dobRaw || mapped.dob,

//           aadhaar_gender: mapped.gender,

//           aadhaar_address: mapped.address,
//         }
//       );

//       closeSheet();

//       return;
//     }

//     // ==========================================================
//     // REAL API FAILURE
//     // ==========================================================

//     const errorMsg =
//       res.data?.data?.responseMessage ||
//       res.data?.message ||
//       res.data?.error ||
//       parsed.responseMessage ||
//       (
//         isFailure
//           ? "Incorrect OTP. Please try again."
//           : "OTP verification failed. Please try again."
//       );

//     setAadhaarOtpError(errorMsg);

//   } catch (err) {

//     console.error(
//       "Aadhaar OTP verification error:",
//       err
//     );

//     setAadhaarOtpError(
//       "OTP verification failed. Please check your internet connection and try again."
//     );

//   } finally {

//     setAadhaarOtpVerifying(false);

//   }
// };
  const handleAadhaarOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    setAadhaarOtpDigits((prev) => {
      const next = [...prev];
      next[index] = digit;
      return next;
    });
    setAadhaarOtpError("");
    if (digit && index < 5) aadhaarOtpRefs.current[index + 1]?.focus();
  };

  const handleAadhaarOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && !aadhaarOtpDigits[index] && index > 0) {
      aadhaarOtpRefs.current[index - 1]?.focus();
    }
  };

  const submitAadhaar = () => {
    console.log("========== PROCEED CLICKED ==========");
    console.log("aadhaarProfile:", aadhaarProfile);
    console.log("panProfile:", panProfile);
    console.log("disburseBank:", disburseBank);
    console.log(
      "Bank Holder:",
      disburseBank?.holderName
    );

    if (aadhaarProfile) {
      setAadhaarError("");
      setEmploymentError("");

      // Aadhaar verified → Employment
      navigate("/apply-new/employment");

      return;
    }
    // AADHAAR CONSENT
    if (!aadhaarConsent) {
      setAadhaarError(
        "Please accept Aadhaar verification consent"
      );
      return;
    }
    setAadhaarError("");

    sendAadhaarOtp(undefined, {
      requireConsent: true,
      openOtpSheet: true,
    });
  };
  const updateDisburseBank = (field, value) => {
    setDisburseBank((prev) => {
      const nextBank = {
        ...prev,
        [field]: value,
      };

      console.log(
        "========== BANK DATA SET =========="
      );
      console.log(
        "BANK UPDATED FIELD:",
        field
      );
      console.log(
        "BANK UPDATED VALUE:",
        value
      );
      console.log(
        "BANK FULL OBJECT:",
        nextBank
      );

      return nextBank;
    });

    setDisburseBankError("");
    setDisburseBankSuccess("");
  };

  // DEMO BRE
  const DEMO_BRE_DECISION = "APPROVED";
  // Testing ke liye:
  // "APPROVED"  → Approved flow
  // "REJECTED"  → Reject flow

  const runDemoBRE = async () => {
    // Demo BRE processing delay
    await new Promise((resolve) => setTimeout(resolve, 1500));

    return {
      decision: DEMO_BRE_DECISION,
      reason:
        DEMO_BRE_DECISION === "APPROVED"
          ? "All demo BRE rules passed."
          : "Demo BRE rule failed.",
    };
  };

  const proceedAfterBankVerification = async () => {
    // AA ACCOUNT FLOW
    if (addBankSource === "referenceReview") {
      setDisburseBankError("");
      setDisburseBankSuccess("");

      setSelfieFaceReady(false);
      setSelfieError("");
      setSelfieHint(
        "Position your face inside the frame and ensure that the circle is green."
      );

      navigate("/apply-new/selfieIntro");

      return;
    }

    if (addBankSource === "aaAccount") {
      const matchedBank =
        ALL_BANKS.find(
          (bank) => bank.name === disburseBank.bankName
        ) || ALL_BANKS[0];

      const last4 = disburseBank.accountNumber.slice(-4);

      const newAccount = {
        id: `acc-${Date.now()}`,
        bankId: matchedBank.id,
        type: "Savings account",
        masked: `*********${last4}`,
      };

      setBankAccounts((prev) => [...prev, newAccount]);
      setSelectedAccountId(newAccount.id);
      setSelectedBankId(matchedBank.id);

      setDisburseBank((prev) => ({
        bankName: "",
        holderName: prev.holderName || "",
        accountNumber: "",
        ifsc: "",
      }));

      setDisburseBankSuccess("");

      navigate("/apply-new/aaAccount");

      return;
    }
    // PAN ↔ AADHAAR ↔ BANK VALIDATION

    const validationResult = validatePanAadhaarBank({
      panProfile,
      aadhaarProfile,
      bankHolderName: disburseBank?.holderName,
    });

    if (!validationResult.ok) {
      setDisburseBankError(validationResult.message);
      setDisburseBankSuccess("");

      setRejectMessage(validationResult.message);
      setShowRejectModal(true);

      return;
    }

    setDisburseBankError("");

    setDisburseBankSuccess(
      "PAN, Aadhaar and Bank details verified successfully."
    );
    // DEMO BRE

    const breResult = await runDemoBRE();

    // BRE APPROVED

    if (breResult.decision === "APPROVED") {

      setActiveReferenceTab(0);
      setReferenceError("");

      // Approved screen
      navigate("/apply-new/approved");

      return;
    }
    if (breResult.decision === "REJECTED") {
      setRejectMessage(
        breResult.reason || "Your application could not be approved."
      );

      setShowRejectModal(true);

      return;
    }
  };

  const continueAfterBankSuccess = async () => {

    // PAN ↔ AADHAAR ↔ BANK VALIDATION

    const validationResult = validatePanAadhaarBank({
      panProfile,
      aadhaarProfile,
      bankHolderName: disburseBank?.holderName,
    });

    // VALIDATION FAILED

    if (!validationResult.ok) {
      setDisburseBankError(validationResult.message);
      setDisburseBankSuccess("");

      setRejectMessage(validationResult.message);
      setShowRejectModal(true);

      return;
    }
    // VALIDATION PASSED

    setDisburseBankError("");
    setDisburseBankSuccess(
      "PAN, Aadhaar and Bank details verified successfully."
    );

    await saveEnquiryProgress("bank_verified", {
      mobile_verified: 1,

      bank_name: disburseBank.bankName,
      bank_holder_name: disburseBank.holderName,
      bank_account_number: disburseBank.accountNumber,
      bank_ifsc: disburseBank.ifsc,

      ...(customerBankingId
        ? { customer_banking_id: customerBankingId }
        : {}),
    });
    // DEMO BRE

    const breResult = await runDemoBRE();

    // BRE APPROVED

    if (breResult.decision === "APPROVED") {
      setActiveReferenceTab(0);
      setReferenceError("");
      navigate("/apply-new/approved");

      return;
    }
    // BRE REJECTED

    if (breResult.decision === "REJECTED") {
      setRejectMessage(
        breResult.reason ||
        "Your application could not be approved."
      );

      setShowRejectModal(true);

      return;
    }
  }

  const submitDisburseBank = async () => {
    if (!disburseBank.bankName) {
      setDisburseBankError("Select bank name");
      return;
    }
    if (!disburseBank.holderName.trim()) {
      setDisburseBankError("Enter account holder name");
      return;
    }
    if (!/^\d{9,18}$/.test(disburseBank.accountNumber)) {
      setDisburseBankError("Enter a valid account number");
      return;
    }
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(disburseBank.ifsc)) {
      setDisburseBankError("Enter a valid IFSC code (e.g. HDFC0001234)");
      return;
    }

    setDisburseBankError("");
    setDisburseBankSuccess("");
    setDisburseBankVerifying(true);
    await saveEnquiryProgress("bank_details_entered", {
      mobile_verified: 1,

      bank_name: disburseBank.bankName,
      bank_holder_name: disburseBank.holderName,
      bank_account_number: disburseBank.accountNumber,
      bank_ifsc: disburseBank.ifsc,
    });
    try {
      const payload = buildBankVerificationPayload({
        bankName: disburseBank.bankName,
        ifsc: disburseBank.ifsc,
        holderName: disburseBank.holderName,
        accountNumber: disburseBank.accountNumber,
      });

      const resp = await axios.post(BANK_AC_VERIFY_URL, payload, {
        headers: { "Content-Type": "application/json" },
        timeout: 45000,
        validateStatus: () => true,
      });

      if (!isBankVerificationSuccess(resp.data)) {
        setDisburseBankError(getBankVerificationMessage(resp.data));
        return;
      }
      // ==========================================
// ACCOUNT HOLDER NAME VALIDATION
// ==========================================
const normalizeName = (name) =>
  String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(
      /^(mr|mrs|ms|miss|shri|smt)\.?\s+/i,
      ""
    )
    .trim();

    const calculateNameSimilarity = (name1, name2) => {
  const a = normalizeName(name1);
  const b = normalizeName(name2);

  if (!a || !b) return 0;

  if (a === b) return 100;

  const wordsA = a.split(" ");
  const wordsB = b.split(" ");

  let matchedWords = 0;

  wordsA.forEach((wordA) => {
    const matched = wordsB.some((wordB) => {
      if (wordA === wordB) {
        return true;
      }

      const maxLength = Math.max(
        wordA.length,
        wordB.length
      );

      const minLength = Math.min(
        wordA.length,
        wordB.length
      );

      if (minLength < 3) {
        return false;
      }

      let matches = 0;

      for (let i = 0; i < minLength; i++) {
        if (wordA[i] === wordB[i]) {
          matches++;
        }
      }

      return (
        matches / maxLength >= 0.7
      );
    });

    if (matched) {
      matchedWords++;
    }
  });

  const totalWords = Math.max(
    wordsA.length,
    wordsB.length
  );

  return (matchedWords / totalWords) * 100;
};
// const enteredHolderName = normalizeName(
//   disburseBank.holderName
// );

// const beneficiaryName = normalizeName(
//   resp.data?.data?.beneficiary_name
// );

// console.log(
//   "ENTERED ACCOUNT HOLDER NAME:",
//   enteredHolderName
// );

// console.log(
//   "BANK BENEFICIARY NAME:",
//   beneficiaryName
// );

// if (
//   !beneficiaryName ||
//   enteredHolderName !== beneficiaryName
// ) {
//   setDisburseBankError(
//     "Account holder name does not match the verified bank account name."
//   );

//   setDisburseBankSuccess("");

//   return;
// }

const enteredHolderName = normalizeName(
  disburseBank.holderName
);

const beneficiaryName = normalizeName(
  resp.data?.data?.beneficiary_name
);

const nameSimilarity = calculateNameSimilarity(
  enteredHolderName,
  beneficiaryName
);

console.log(
  "ENTERED ACCOUNT HOLDER NAME:",
  enteredHolderName
);

console.log(
  "BANK BENEFICIARY NAME:",
  beneficiaryName
);

console.log(
  "NAME SIMILARITY:",
  nameSimilarity.toFixed(2) + "%"
);

// Minimum 70% matching required
if (
  !beneficiaryName ||
  // nameSimilarity < 70
  nameSimilarity < 15
) {
  setDisburseBankError(
    `Account holder name does not match the verified bank account name. Match: ${nameSimilarity.toFixed(
      0
    )}%`
  );

  setDisburseBankSuccess("");

  return;
}
      const successMessage = getBankVerificationMessage(
        resp.data,
        "Account verified successfully."
      );
      const bankingId = getBankVerificationBankingId(resp.data);
      if (bankingId) setCustomerBankingId(bankingId);

      mergeCustomerSession({
        saved_fields: {
          ...(getCustomerSession()?.saved_fields || {}),
          disburse_bank: disburseBank,
          ...(bankingId ? { cust_banking_id: bankingId } : {}),
        },
      });

      setDisburseBankSuccess(successMessage);
      await saveEnquiryProgress("bank_verified", {
        mobile_verified: 1,

        bank_name: disburseBank.bankName,
        bank_holder_name: disburseBank.holderName,
        bank_account_number: disburseBank.accountNumber,
        bank_ifsc: disburseBank.ifsc,

        ...(bankingId
          ? { customer_banking_id: bankingId }
          : {}),
      });
      setDisburseBankVerifying(false);
      setTimeout(() => {
        navigate("/apply-new/emandate");

        if (addBankSource !== "referenceReview") {
          proceedAfterBankVerification();
        }
      }, 1800);
    } catch {
      setDisburseBankError("Bank verification failed. Please try again.");
    } finally {
      setDisburseBankVerifying(false);
    }
  };

  const openSheet = (name) => setSheet(name);
  const closeSheet = () => {
    setSheetVisible(false);
    setTimeout(() => setSheet(null), 280);
  };
  const sendOtp = async () => {
    if (!MOBILE_REGEX.test(mobile)) {
      setMobileError("Enter a valid 10-digit mobile number");
      return;
    }
    if (!consent) {
      setMobileError("Please allow credit bureau access to continue");
      return;
    }

    setOtpSending(true);
    setMobileError("");

    try {
      const params = new URLSearchParams();
      params.append("mobile", mobile);

      const resp = await axios.post(SEND_OTP_URL, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-API-KEY": "lkru^%&jND244ht5a",
        },

        timeout: 20000,
      });
      const apiResponse = resp.data?.api_response || {};
      const apiReturn = apiResponse?.return;
      const apiMessage = Array.isArray(apiResponse?.message)
        ? apiResponse.message[0]
        : apiResponse?.message || "";

      if (
        apiReturn === false ||
        apiResponse?.status_code === 411 ||
        String(apiMessage).toLowerCase().includes("invalid")
      ) {
        setMobileError(apiMessage || "Invalid mobile number");
        return;
      }

      if (apiReturn === true || resp.data?.status === true) {
        await saveEnquiryProgress("mobile", {
          mobile_verified: 0,
        });
        setOtpDigits(["", "", "", "", "", ""]);
        setOtpError("");
        setResendTimer(OTP_RESEND_SECONDS);
        openSheet("otp");
        setTimeout(() => otpRefs.current[0]?.focus(), 320);
        return;
      }

      setMobileError(resp.data?.message || apiMessage || "Failed to send OTP");

    } catch (err) {
      console.error("SEND OTP ERROR:", err);
      console.error("SEND OTP RESPONSE:", err?.response?.data);

      setMobileError(
        err?.response?.data?.message ||
        err?.message ||
        "Could not send OTP. Please try again."
      );
    }
    finally {
      setOtpSending(false);
    }
  };

  const handleOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const next = [...otpDigits];
    next[index] = digit;
    setOtpDigits(next);
    setOtpError("");
    if (digit && index < 5) otpRefs.current[index + 1]?.focus();
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otpDigits[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpPaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    const next = ["", "", "", "", "", ""];
    pasted.split("").forEach((digit, i) => {
      next[i] = digit;
    });
    setOtpDigits(next);
    otpRefs.current[Math.min(pasted.length, 5)]?.focus();
  };

  // const verifyOtp = async () => {
  //   const otp = otpDigits.join("");
  //   if (otp.length !== 6) {
  //     setOtpError("Enter the 6-digit OTP");
  //     return;
  //   }

  //   setOtpVerifying(true);
  //   setOtpError("");

  //   try {
  //     const params = new URLSearchParams();
  //     params.append("mobile", mobile);
  //     params.append("otp", otp);

  //     const resp = await axios.post(VERIFY_OTP_URL, params, {
  //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //       timeout: 20000,
  //     });

  //     if (resp.data?.status === true) {
  //       const leadId = resp.data?.data?.lead_id;

  // if (leadId) {
  //   const finalLeadId = String(leadId).trim();

  //   setCustomerLeadId(finalLeadId);

  //   mergeCustomerSession({
  //     lead_id: finalLeadId,
  //   });

  //   console.log("========== OTP LEAD ID ==========");
  //   console.log("OTP RESPONSE LEAD ID:", finalLeadId);
  // }
  //       try {
  //         await saveEnquiryProgress("mobile_verified", {
  //           mobile_verified: 1,
  //         });
  //         const loginResult = await loginCustomerByMobile(mobile);
  //         const stored = getCustomerSession();
  //         const targetScreen = loginResult.ok
  //           ? pickResumeScreen(stored, loginResult.login)
  //           : "location";

  //         if (loginResult.ok && loginResult.login) {
  //           restoreFromLoginSession({
  //             ...loginResult.login,
  //             screen: targetScreen,
  //           });
  //         }

  //         closeSheet();
  //         setTimeout(() => navigate('/apply-new/' + targetScreen), 280);
  //       } catch {
  //         closeSheet();
  //         setTimeout(() => navigate('/apply-new/'), 280);
  //       }
  //       return;
  //     }

  //     setOtpError(resp.data?.message || "Entered OTP is incorrect");
  //   } catch (err) {
  //     setOtpError("OTP verification failed. Please try again.");
  //   } finally {
  //     setOtpVerifying(false);
  //   }
  // };

// const runLocationBRE = async ({
//   latitude,
//   longitude,
// }) => {
//   const stored = getCustomerSession() || {};

//   const leadId =
//     customerLeadId ||
//     stored.lead_id ||"LEAD001"||
//     "";
//   // const leadId = customerLeadId || stored.lead_id || "";

//   const userId =
//     stored.user_id ||
//     "USER561"||"";
//   // const userId = stored.user_id || "";

//   const referenceId =
//     stored.reference_id ||"REF001"||
//     "";
//   // const referenceId = stored.reference_id || "";

//   if (!userId) {
//     throw new Error("User ID is missing");
//   }

//   if (!referenceId) {
//     throw new Error("Reference ID is missing");
//   }

//   if (!leadId) {
//     throw new Error("Lead ID is missing");
//   }

//   const payload = {
//     user_id: userId,
//     reference_id: referenceId,
//     input_data: {
//       lead_id: leadId,
//       latitude: Number(latitude),
//       longitude: Number(longitude),
//     },
//   };

//   console.log("========== LOCATION BRE REQUEST ==========");
//   console.log("LOCATION BRE PAYLOAD:", payload);

//   const response = await axios.post(
//     locationBreUrl(),
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       timeout: 20000,
//       withCredentials: true,
//       validateStatus: () => true,
//     }
//   );

//   console.log("========== LOCATION BRE RESPONSE ==========");
//   console.log("LOCATION BRE RESPONSE:", response.data);

//   return response.data;
// };

  // const requestLocation = () => {
  //   setLocationError("");
  //   setLocationLoading(true);

  //   if (!navigator.geolocation) {
  //     setLocationLoading(false);
  //     setLocationError("Location is not supported on this browser");
  //     return;
  //   }

  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       const latitude = String(position.coords.latitude || "");
  //       const longitude = String(position.coords.longitude || "");
  //       const next = {
  //         latitude,
  //         longitude,
  //         coordinates: latitude && longitude ? `${latitude},${longitude}` : "",
  //       };
  //       setLocationCoords(next);
  //       persistLocation(next);
  //       setLocationLoading(false);
  //       await saveCustomerProgress(2, {
  //         latitude,
  //         longitude,
  //         coordinates: next.coordinates,
  //       });


  //       await saveEnquiryProgress("location", {
  //         mobile_verified: 1,
  //         latitude,
  //         longitude,
  //         coordinates: next.coordinates,
  //       });
  //       navigate("/apply-new/details");
  //     },
  //     () => {
  //       setLocationLoading(false);
  //       setLocationError("Please allow location to continue");
  //     },
  //     { enableHighAccuracy: false, timeout: 12000, maximumAge: 60000 }
  //   );
  // };

const verifyOtp = async () => {
  const otp = otpDigits.join("");

  if (otp.length !== 6) {
    setOtpError("Enter the 6-digit OTP");
    return;
  }

  setOtpVerifying(true);
  setOtpError("");

  try {
    const params = new URLSearchParams();
    params.append("mobile", mobile);
    params.append("otp", otp);

    const resp = await axios.post(VERIFY_OTP_URL, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      timeout: 20000,
    });

    if (resp.data?.status === true) {

      // Get lead_id from Verify OTP response
      const leadId = resp.data?.data?.lead_id;

      if (leadId) {
        const finalLeadId = String(leadId).trim();

        setCustomerLeadId(finalLeadId);

        mergeCustomerSession({
          lead_id: finalLeadId,
        });

        console.log("========== OTP LEAD ID ==========");
        console.log("OTP RESPONSE LEAD ID:", finalLeadId);
      }

      try {
        await saveEnquiryProgress("mobile_verified", {
          mobile_verified: 1,
          ...(leadId
            ? { lead_id: String(leadId).trim() }
            : {}),
        });

        const loginResult = await loginCustomerByMobile(mobile);

        // Make sure OTP lead_id is retained after login
        if (leadId) {
          const finalLeadId = String(leadId).trim();

          setCustomerLeadId(finalLeadId);

          mergeCustomerSession({
            lead_id: finalLeadId,
          });

          console.log(
            "========== FINAL CUSTOMER LEAD ID =========="
          );
          console.log("FINAL LEAD ID:", finalLeadId);
        }

        const stored = getCustomerSession();

        const targetScreen = loginResult.ok
          ? pickResumeScreen(stored, loginResult.login)
          : "location";

        if (loginResult.ok && loginResult.login) {
          restoreFromLoginSession({
            ...loginResult.login,
            screen: targetScreen,
          });

          // Restore OTP lead_id again if login session changed it
          if (leadId) {
            const finalLeadId = String(leadId).trim();

            setCustomerLeadId(finalLeadId);

            mergeCustomerSession({
              lead_id: finalLeadId,
            });
          }
        }

        closeSheet();

        setTimeout(() => {
          navigate("/apply-new/" + targetScreen);
        }, 280);

      } catch (error) {
        console.error("Post OTP login/session error:", error);

        closeSheet();

        setTimeout(() => {
          navigate("/apply-new/");
        }, 280);
      }

      return;
    }

    // setOtpError(
    //   resp.data?.message || "Entered OTP is incorrect"
    // );
    const apiErrorMessage =
  resp.data?.message ||
  resp.data?.err ||
  resp.data?.msg ||
  resp.data?.error ||
  resp.data?.data?.message ||
  resp.data?.data?.err ||
  "Entered OTP is incorrect";

console.log("OTP API ERROR MESSAGE:", apiErrorMessage);

setOtpError(apiErrorMessage);

  // } catch (err) {
  //   console.error("OTP verification error:", err);
  //   setOtpError(
  //     "OTP verification failed. Please try again."
  //   );

  // } 

  } catch (err) {
  console.error("OTP verification error:", err);

  const apiErrorMessage =
    err?.response?.data?.message ||
    err?.response?.data?.err ||
    err?.response?.data?.msg ||
    err?.response?.data?.error ||
    err?.response?.data?.data?.message ||
    err?.response?.data?.data?.err ||
    err?.message ||
    "OTP verification failed. Please try again.";

  console.error(
    "OTP API ERROR MESSAGE:",
    apiErrorMessage
  );

  setOtpError(apiErrorMessage);
}

  finally {
    setOtpVerifying(false);
  }
};

//   const runLocationBRE = async ({
//   latitude,
//   longitude,
// }) => {
//   const stored = getCustomerSession() || {};

//   // Lead ID
//   // TEMPORARY: backend se dynamic lead_id abhi nahi aa rahi
//   const leadId = String(
//     customerLeadId ||
//     stored.lead_id ||
//     "LEAD001"
//   ).trim();

//   const userId = String(
//     stored.user_id ||
//     "USER561"
//   ).trim();

//   const referenceId = String(
//     stored.reference_id ||
//     "REF001"
//   ).trim();

//   if (!userId) {
//     throw new Error("User ID is missing");
//   }

//   if (!referenceId) {
//     throw new Error("Reference ID is missing");
//   }

//   if (!leadId) {
//     throw new Error("Lead ID is missing");
//   }

//   const payload = {
//     user_id: userId,
//     reference_id: referenceId,
//     input_data: {
//       lead_id: leadId,
//       latitude: Number(latitude),
//       longitude: Number(longitude),
//     },
//   };

//   console.log(
//     "========== LOCATION BRE REQUEST =========="
//   );

//   console.log(
//     "LOCATION BRE PAYLOAD:",
//     payload
//   );

//   const response = await axios.post(
//     locationBreUrl(),
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       timeout: 20000,
//       withCredentials: true,
//       validateStatus: () => true,
//     }
//   );

//   console.log(
//     "========== LOCATION BRE RESPONSE =========="
//   );

//   console.log(
//     "LOCATION BRE RESPONSE:",
//     response.data
//   );

//   // ---------------------------------------
//   // FUTURE: BACKEND DYNAMIC LEAD ID
//   // ---------------------------------------

//   const responseLeadId =
//     response.data?.data?.lead_id ||
//     response.data?.lead_id ||
//     "";

//   if (responseLeadId) {
//     const finalLeadId = String(responseLeadId).trim();

//     setCustomerLeadId(finalLeadId);

//     mergeCustomerSession({
//       lead_id: finalLeadId,
//     });

//     console.log(
//       "LOCATION BRE DYNAMIC LEAD ID:",
//       finalLeadId
//     );
//   }

//   return response.data;
// };

const runLocationBRE = async ({
  latitude,
  longitude,
}) => {
  const stored = getCustomerSession() || {};

  // Lead ID comes from Verify OTP response
  // const leadId = String(
  //   customerLeadId ||
  //   stored.lead_id ||
  //   ""
  // ).trim();
  const leadId = String(
  stored?.lead_id ||
  customerLeadId ||
  ""
).trim();

  if (!leadId) {
    throw new Error("Lead ID is missing");
  }

  const payload = {
    input_data: {
      lead_id: leadId,
      latitude: String(latitude),
      longitude: String(longitude),
    },
  };

  console.log("========== LOCATION BRE REQUEST ==========");
  console.log("LOCATION BRE PAYLOAD:", payload);

  const response = await axios.post(
    // "https://fundswalla.in/Api/TaskApi/locationBre",
    "https://fundswalla.in/Api/AutomationApi/locationBre",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 20000,
      withCredentials: true,
      validateStatus: () => true,
    }
  );

  console.log("========== LOCATION BRE RESPONSE ==========");
  console.log("LOCATION BRE RESPONSE:", response.data);

  // If BRE response also returns lead_id, save it
  const responseLeadId =
    response.data?.data?.lead_id ||
    response.data?.lead_id ||
    "";

  if (responseLeadId) {
    const finalLeadId = String(responseLeadId).trim();

    setCustomerLeadId(finalLeadId);

    mergeCustomerSession({
      lead_id: finalLeadId,
    });

    console.log("LOCATION BRE LEAD ID:", finalLeadId);
  }

  return response.data;
};
const requestLocation = () => {
  setLocationError("");
  setLocationLoading(true);

  if (!navigator.geolocation) {
    setLocationLoading(false);
    setLocationError("Location is not supported on this browser");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const latitude = String(position.coords.latitude || "");
      const longitude = String(position.coords.longitude || "");

      const next = {
        latitude,
        longitude,
        coordinates:
          latitude && longitude
            ? `${latitude},${longitude}`
            : "",
      };

      setLocationCoords(next);
      persistLocation(next);

      try {
        // ---------------------------------------
        // 1. SAVE CUSTOMER PROGRESS
        // ---------------------------------------
        await saveCustomerProgress(2, {
          latitude,
          longitude,
          coordinates: next.coordinates,
        });

        // ---------------------------------------
        // 2. SAVE ENQUIRY PROGRESS
        // ---------------------------------------
        await saveEnquiryProgress("location", {
          mobile_verified: 1,
          latitude,
          longitude,
          coordinates: next.coordinates,
        });

        // ---------------------------------------
        // 3. LOCATION BRE
        // ---------------------------------------
        const breResponse = await runLocationBRE({
          latitude,
          longitude,
        });

        console.log(
          "LOCATION BRE DECISION:",
          breResponse?.data?.decision
        );

        // ---------------------------------------
        // 4. BRE PASSED
        // ---------------------------------------
        if (
          breResponse?.status === true &&
          breResponse?.data?.decision === "Proceed to Next Rule"
        ) {
          navigate("/apply-new/details");
          return;
        }

        // ---------------------------------------
        // 5. BRE REJECTED
        // ---------------------------------------
        const decision = String(
          breResponse?.data?.decision || ""
        ).toLowerCase();

        if (
          decision.includes("reject") ||
          decision.includes("decline")
        ) {
          setRejectMessage(
            breResponse?.data?.decision_reason ||
            breResponse?.message ||
            "Your location is not eligible."
          );

          setShowRejectModal(true);
          return;
        }
  
        setLocationError(
          breResponse?.message ||
          "Unable to verify your location. Please try again."
        );
      } catch (error) {
        console.error("LOCATION BRE ERROR:", error);

        setLocationError(
          error?.response?.data?.message ||
          error?.message ||
          "Unable to verify your location. Please try again."
        );
      } finally {
        setLocationLoading(false);
      }
    },
    () => {
      setLocationLoading(false);
      setLocationError("Please allow location to continue");
    },
    {
      enableHighAccuracy: false,
      timeout: 12000,
      maximumAge: 60000,
    }
  );
};
  const applyVerifiedPanProfile = (panValue, verifyData) => {
    const panInfo = verifyData?.data || {};
    const fullName =
      panInfo.fullName ||
      [panInfo.firstName, panInfo.middleName, panInfo.lastName]
        .filter(Boolean)
        .join(" ") ||
      "—";

    const nextProfile = {
      name: fullName,
      fatherName:
        panInfo.fatherName ||
        panInfo.father_name ||
        panInfo.fathersName ||
        "—",
      pan: panInfo.pan || panValue,
      dob: formatDob(panInfo.dob || panInfo.dateOfBirth),
      gender: panInfo.gender || "",
      address: panInfo.address || "",
      aadhaarLinked: panInfo.aadhaarLinked,
      maskedAadhaarNumber: panInfo.maskedAadhaarNumber || "",
      responseCode: verifyData.responseCode || "",
      responseMessage: String(verifyData.responseMessage || ""),
      referenceId: verifyData.referenceId || "",
      firstName: panInfo.firstName || "",
      lastName: panInfo.lastName || "",
      category: panInfo.category || "",
    };
    console.log("========== PAN PROFILE SET ==========");
    console.log("PAN VALUE:", panValue);
    console.log("PAN FULL OBJECT:", nextProfile);
    setPanProfile(nextProfile);
    mergeCustomerSession({
      saved_fields: {
        ...(getCustomerSession()?.saved_fields || {}),
        pan: panValue,
        pan_profile: nextProfile,
      },
    });
  };

  const runPanApis = async (rawPan) => {
    const panValue = String(rawPan || "").trim().toUpperCase();
    if (panValue.length !== 10 || !PAN_REGEX.test(panValue)) {
      return { ok: false, reason: "invalid" };
    }

    const customerCheck = await checkCustomerByPan(panValue);
    if (customerCheck.blocked) {
      setPanError(
        customerCheck.message ||
        "This PAN is already registered. Cannot re-apply."
      ); 
      setPanStatus("");
      setPanProfile(null);
      return { ok: false, reason: "blocked" };
    }

    // const verifyRes = await axios.get(VERIFY_PAN_URL, {
    //   params: { pan: panValue },
    //   timeout: 30000,
    // });

    const stored = getCustomerSession() || {};
const saved = stored?.saved_fields || {};

const leadId = String(
  stored?.lead_id ||
  saved?.lead_id ||
  customerLeadId ||
  ""
).trim();

if (!leadId) {
  throw new Error("Lead ID is missing");
}

const verifyRes = await axios.post(
  VERIFY_PAN_URL,
  {
    pan: panValue,
    lead_id: leadId,
  },
  {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    timeout: 30000,
    validateStatus: () => true,
  }
);

console.log(
  "VERIFY PAN RESPONSE:",
  verifyRes.data
);
    const verifyData = verifyRes.data?.data || {};
    const responseCode = verifyData.responseCode || "";
    const responseMessage = String(verifyData.responseMessage || "");

    if (
      responseCode === "ENI004" ||
      responseMessage.toLowerCase().includes("no information found")
    ) {
      setPanError("PAN does not exist. Enter your correct PAN.");
      setPanStatus("");
      setPanProfile(null);
      return { ok: false, reason: "not_found" };
    }

    if (responseCode !== "SRC001") {
      setPanError(responseMessage || "Unable to verify PAN. Please try again.");
      setPanStatus("");
      setPanProfile(null);
      return { ok: false, reason: "verify_fail" };
    }

    // applyVerifiedPanProfile(panValue, verifyData);
    // mergeCustomerSession({
    //   saved_fields: {
    //     ...(getCustomerSession()?.saved_fields || {}),
    //     pan: panValue,
    //     email: normalizeEmailInput(email),
    //   },
    // });
    // setPanError("");
    // setPanStatus(
    //   customerCheck.message ||
    //   responseMessage ||
    //   "PAN Verification Complete!"
    // );
    // lastFetchedPanRef.current = panValue;
    // return { ok: true };

    applyVerifiedPanProfile(panValue, verifyData);

    mergeCustomerSession({
      saved_fields: {
        ...(getCustomerSession()?.saved_fields || {}),
        pan: panValue,
        email: normalizeEmailInput(email),
      },
    });

    setPanError("");
    setPanStatus(
      customerCheck.message ||
      responseMessage ||
      "PAN Verification Complete!"
    );

    lastFetchedPanRef.current = panValue;

    // Save PAN verification progress
    await saveEnquiryProgress("pan_verified", {
      mobile_verified: 1,

      Name: verifyData?.data?.fullName || "",
      first_name: verifyData?.data?.fullName || "",

      pan: panValue,
      pancard: panValue,

      email: normalizeEmailInput(email),
    });

    return { ok: true };
  };

  const checkPanOnEnter = async (rawPan) => {
    const panValue = String(rawPan || "").trim().toUpperCase();
    if (panValue.length !== 10 || !PAN_REGEX.test(panValue)) return;
    if (panCheckLockRef.current) return;
    if (lastFetchedPanRef.current === panValue && panProfile?.pan === panValue) return;

    panCheckLockRef.current = true;
    setPanChecking(true);
    setPanError("");
    setPanStatus("");

    try {
      await runPanApis(panValue);
    } catch {
      setPanError("Unable to check PAN status. Please try again.");
      setPanStatus("");
      setPanProfile(null);
    } finally {
      panCheckLockRef.current = false;
      setPanChecking(false);
    }
  };



const checkEligibility = async () => {
  const panValue = pan.trim().toUpperCase();
  const emailValue = normalizeEmailInput(email);

  const stored = getCustomerSession() || {};
  const saved = stored?.saved_fields || {};

  const leadId = String(
    stored?.lead_id ||
    saved?.lead_id ||
    customerLeadId ||
    ""
  ).trim();

  const panMsg = !panValue
    ? "PAN is required"
    : PAN_REGEX.test(panValue)
      ? ""
      : "Enter a valid PAN (e.g. ABCDE1234F)";

  const emailMsg = validateEmail(emailValue);

  if (panMsg) {
    setPanError(panMsg);
    setPanStatus("");
  }

  setEmailError(emailMsg);

  if (panMsg || emailMsg) return;

  if (!leadId) {
    setEmailError("Lead ID is missing");
    return;
  }

  // PAN API se pehle hi reject/re-apply error aa gaya ho
  if (panError && /cannot re-apply/i.test(panError)) {
    return;
  }

  // PAN complete hone ke baad API call ho chuki honi chahiye
  if (
    lastFetchedPanRef.current !== panValue ||
    !panProfile?.pan ||
    panProfile?.pan !== panValue
  ) {
    setPanError(
      "Please wait for PAN verification to complete."
    );
    return;
  }

  setChecking(true);
  setEmailError("");

  try {
    // =========================================
    // UPDATE EMAIL API
    // =========================================
    console.log("========== UPDATE EMAIL ==========");
    console.log("LEAD ID:", leadId);
    console.log("EMAIL:", emailValue);

    const emailResponse = await axios.post(
      "https://fundswalla.in/Api/AutomationApi/updateEmail",
      {
        lead_id: leadId,
        email: emailValue,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 30000,
        validateStatus: () => true,
      }
    );

    console.log(
      "UPDATE EMAIL RESPONSE:",
      emailResponse.data
    );

    if (
      emailResponse.status < 200 ||
      emailResponse.status >= 300 ||
      emailResponse.data?.status === false
    ) {
      throw new Error(
        emailResponse.data?.message ||
        emailResponse.data?.msg ||
        emailResponse.data?.err ||
        "Unable to update email."
      );
    }

    console.log(
      "========== EMAIL UPDATED SUCCESSFULLY =========="
    );

    // =========================================
    // PAN ALREADY VERIFIED
    // NOW SHOW PAN CONFIRMATION
    // =========================================

    console.log(
      "========== OPENING PAN CONFIRMATION =========="
    );

    openSheet("confirm");

  } catch (error) {
    console.error(
      "CHECK ELIGIBILITY ERROR:",
      error
    );

    console.error(
      "API RESPONSE:",
      error?.response?.data
    );

    setEmailError(
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.response?.data?.err ||
      error?.message ||
      "Unable to process your request."
    );

  } finally {
    setChecking(false);
  }
};

// const startAadhaarDigiLocker = async () => {
//   if (aadhaarDigiLoading) return;

//   // Popup blocker avoid karne ke liye user click ke time blank tab open
//   const digiWindow = window.open(
//     "",
//     "_blank"
//   );

//   if (!digiWindow) {
//     setAadhaarDigiError(
//       "Unable to open DigiLocker. Please allow popups and try again."
//     );
//     return;
//   }

//   try {
//     setAadhaarDigiLoading(true);
//     setAadhaarDigiError("");

//     console.log(
//       "========== DIGILOCKER API START =========="
//     );

//     const response = await axios.post(
//       SEND_AADHAAR_OTP_URL,
//       {},
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         timeout: 45000,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "DIGILOCKER API RESPONSE:",
//       response.data
//     );

//     if (
//       response.status < 200 ||
//       response.status >= 300
//     ) {
//       throw new Error(
//         response.data?.message ||
//         response.data?.msg ||
//         response.data?.err ||
//         "Unable to start Aadhaar verification."
//       );
//     }

//     const responseData = response.data || {};

//     // API response mein URL jis field mein aaye,
//     // usko yahan pick kar rahe hain.
//     const digiLockerUrl =
//       responseData?.url ||
//       responseData?.digilocker_url ||
//       responseData?.redirect_url ||
//       responseData?.data?.url ||
//       responseData?.data?.digilocker_url ||
//       responseData?.data?.redirect_url ||
//       "";

//     if (!digiLockerUrl) {
//       digiWindow.close();

//       throw new Error(
//         responseData?.message ||
//         responseData?.msg ||
//         responseData?.err ||
//         "DigiLocker URL was not received."
//       );
//     }

//     console.log(
//       "========== DIGILOCKER URL =========="
//     );
//     console.log(digiLockerUrl);

//     // Generated DigiLocker URL ko new tab mein open karo
//     digiWindow.location.href = digiLockerUrl;

//     console.log(
//       "========== DIGILOCKER TAB OPENED =========="
//     );

//   } catch (error) {
//     console.error(
//       "DIGILOCKER API ERROR:",
//       error
//     );

//     if (!digiWindow.closed) {
//       digiWindow.close();
//     }

//     setAadhaarDigiError(
//       error?.response?.data?.message ||
//       error?.response?.data?.msg ||
//       error?.response?.data?.err ||
//       error?.message ||
//       "Unable to start Aadhaar verification."
//     );
//   } finally {
//     setAadhaarDigiLoading(false);
//   }
// };

  // const confirmAndProceed = async () => {
  //   closeSheet();
  //   await saveCustomerProgress(3);

  //   setTimeout(() => {
  //     setAadhaarError("");
  //     setAadhaarStatus("");
  //     navigate("/apply-new/aadhaarKyc");
  //   }, 280);
  // };

// const startAadhaarDigiLocker = async (digiWindow) => {
//   if (aadhaarDigiLoading) return;

//   try {
//     setAadhaarDigiLoading(true);
//     setAadhaarDigiError("");

//     console.log(
//       "========== DIGILOCKER API START =========="
//     );

//     const response = await axios.post(
//       SEND_AADHAAR_OTP_URL,
//       {},
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         timeout: 45000,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "DIGILOCKER API RESPONSE:",
//       response.data
//     );

//     // API / HTTP error
//     if (
//       response.status < 200 ||
//       response.status >= 300 ||
//       response.data?.status === false
//     ) {
//       throw new Error(
//         response.data?.message ||
//         response.data?.msg ||
//         response.data?.err ||
//         "Unable to start Aadhaar verification."
//       );
//     }

//     // =========================================
//     // ACTUAL DIGITAP RESPONSE
//     // response.data.data.kycUrl
//     // =========================================
//     const digiLockerUrl =
//       response.data?.data?.kycUrl || "";

//     if (!digiLockerUrl) {
//       throw new Error(
//         response.data?.message ||
//         "DigiLocker URL was not received."
//       );
//     }

//     console.log(
//       "========== DIGILOCKER URL =========="
//     );
//     console.log(digiLockerUrl);

//     // =========================================
//     // OPEN GENERATED KYC URL IN NEW TAB
//     // =========================================
//     if (digiWindow && !digiWindow.closed) {
//       digiWindow.location.href = digiLockerUrl;
//     } else {
//       throw new Error(
//         "Unable to open DigiLocker tab."
//       );
//     }

//     console.log(
//       "========== DIGILOCKER TAB OPENED =========="
//     );

//   } catch (error) {
//     console.error(
//       "DIGILOCKER API ERROR:",
//       error
//     );

//     if (digiWindow && !digiWindow.closed) {
//       digiWindow.close();
//     }

//     setAadhaarDigiError(
//       error?.response?.data?.message ||
//       error?.response?.data?.msg ||
//       error?.response?.data?.err ||
//       error?.message ||
//       "Unable to start Aadhaar verification."
//     );

//   } finally {
//     setAadhaarDigiLoading(false);
//   }
// };

// const confirmAndProceed = async () => {
//   if (aadhaarDigiLoading) return;

//   setAadhaarDigiError("");

//   try {
//     await saveCustomerProgress(3);

//     await startAadhaarDigiLocker();

//   } catch (error) {
//     console.error(
//       "CONFIRM / DIGILOCKER ERROR:",
//       error
//     );

//     setAadhaarDigiError(
//       error?.message ||
//       "Unable to start Aadhaar verification."
//     );
//   }
// };

const startAadhaarDigiLocker = async (digiWindow) => {
  if (aadhaarDigiLoading) return;

  try {
    setAadhaarDigiLoading(true);
    setAadhaarDigiError("");

    const stored = getCustomerSession() || {};
    const saved = stored?.saved_fields || {};

    const leadId = String(
      stored?.lead_id ||
      saved?.lead_id ||
      customerLeadId ||
      ""
    ).trim();

    console.log(
      "========== DIGILOCKER API START =========="
    );

    console.log("LEAD ID:", leadId);

    if (!leadId) {
      throw new Error("Lead ID is missing");
    }

    const response = await axios.post(
      SEND_AADHAAR_OTP_URL,
      {
        lead_id: leadId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        timeout: 45000,
        validateStatus: () => true,
      }
    );

    console.log(
      "DIGILOCKER API RESPONSE:",
      response.data
    );

    // =========================================
    // API ERROR
    // =========================================
    if (
      response.status < 200 ||
      response.status >= 300 ||
      response.data?.status === false
    ) {
      throw new Error(
        response.data?.message ||
        response.data?.msg ||
        response.data?.err ||
        "Unable to start Aadhaar verification."
      );
    }

    // =========================================
    // DIGITAP KYC URL
    // =========================================
    const digiLockerUrl =
      response.data?.data?.kycUrl || "";

    if (!digiLockerUrl) {
      throw new Error(
        response.data?.message ||
        "DigiLocker URL was not received."
      );
    }

    console.log(
      "========== DIGILOCKER URL =========="
    );
    console.log(digiLockerUrl);

    // =========================================
    // OPEN IN SAME NEW TAB
    // =========================================
    if (
      digiWindow &&
      !digiWindow.closed
    ) {
      digiWindow.location.href =
        digiLockerUrl;
    } else {
      throw new Error(
        "Unable to open DigiLocker tab."
      );
    }

    console.log(
      "========== DIGILOCKER TAB OPENED =========="
    );

  } catch (error) {
    console.error(
      "DIGILOCKER API ERROR:",
      error
    );

    if (
      digiWindow &&
      !digiWindow.closed
    ) {
      digiWindow.close();
    }

    setAadhaarDigiError(
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.response?.data?.err ||
      error?.message ||
      "Unable to start Aadhaar verification."
    );

  } finally {
    setAadhaarDigiLoading(false);
  }
};

const confirmAndProceed = async () => {
  if (aadhaarDigiLoading) return;

  setAadhaarDigiError("");

  // User click ke immediately andar tab open
  const digiWindow = window.open(
    "",
    "_blank"
  );

  if (!digiWindow) {
    setAadhaarDigiError(
      "Unable to open DigiLocker. Please allow popups and try again."
    );
    return;
  }

  try {
    // Optional loading content
    digiWindow.document.title = "Opening DigiLocker...";
    digiWindow.document.body.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100vh;
        font-family:Arial,sans-serif;
        font-size:16px;
      ">
        Opening DigiLocker...
      </div>
    `;

    await saveCustomerProgress(3);

    await startAadhaarDigiLocker(
      digiWindow
    );

  } catch (error) {
    console.error(
      "CONFIRM / DIGILOCKER ERROR:",
      error
    );

    if (!digiWindow.closed) {
      digiWindow.close();
    }

    setAadhaarDigiError(
      error?.message ||
      "Unable to start Aadhaar verification."
    );
  }
};
  const updateEmployment = (key, value) => {
    setEmployment((prev) => ({ ...prev, [key]: value }));
    if (key === "salary") {
      if (value && Number(value) < 20000) {
        setEmploymentError(
          "Net monthly salary must be at least ₹20,000"
        );
        return;
      }
    }
    setEmploymentError("");
  };
  //runng code but test to comment when adhar is running correctly then uncomment the niche wale ko 
// const fetchCreditAnalytics = async () => {
//   // const leadId = String(customerLeadId || "").trim();
//     // const leadId = "LEAD001"; 
//     const stored = getCustomerSession() || {};

// const leadId = String(stored?.lead_id ||customerLeadId ||"").trim();

//   if (!leadId) {
//     throw new Error("Lead ID is missing");
//   }
//   const fullName = String(aadhaarProfile?.name ||aadhaarProfile?.raw?.name ||panProfile?.name 
//     ||stored?.saved_fields?.aadhaar_profile?.name ||stored?.saved_fields?.pan_profile?.name ||""
// ).trim();

// const nameParts = fullName.split(/\s+/).filter(Boolean);

// const firstName = (nameParts[0] || "").toUpperCase();

// const lastName = (nameParts.slice(1).join(" ") || "").toUpperCase();

// console.log("========== NAME FOR CREDIT ANALYTICS ==========");
// console.log("FULL NAME:", fullName);
// console.log("FIRST NAME:", firstName);
// console.log("LAST NAME:", lastName);
// const payload = {
//   lead_id: String(stored?.lead_id ||customerLeadId ||"").trim(),
//   mobile_no: mobile,

//   // first_name: panProfile?.firstName || "",
//   // last_name: panProfile?.lastName || "",
//   first_name: firstName,
// last_name: lastName,

//   pan: panProfile?.pan || pan || "",

//   // address:
//   //   panProfile?.address ||
//   //   aadhaarProfile?.address ||
//   //   "",
//     address:aadhaarProfile?.raw?.state ||"",

//   city:
//     aadhaarProfile?.raw?.district || "",

//   state:
//     aadhaarProfile?.raw?.state || "",

//   pincode:
//     aadhaarProfile?.raw?.pincode || "",

//   // DOB => YYYY-MM-DD
//   date_of_birth: (() => {
//     const dob = panProfile?.dob || "";

//     if (!dob) return "";

//     if (dob.includes("/")) {
//       const [day, month, year] = dob.split("/");

//       if (day && month && year) {
//         return `${year}-${month.padStart(2, "0")}-${day.padStart(
//           2,
//           "0"
//         )}`;
//       }
//     }

//     return dob;
//   })(),

//   email: email || "",
//   gender: panProfile?.gender || "",
// };

// console.log(
//   "========== CREDIT ANALYTICS FINAL PAYLOAD =========="
// );
// console.log(JSON.stringify(payload, null, 2));
//   console.log("CREDIT ANALYTICS REQUEST:", payload);

//   const response = await axios.post(
//     creditAnalyticsUrl(),
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       timeout: 30000,
//       withCredentials: true,
//       validateStatus: () => true,
//     }
//   );

//   console.log("CREDIT ANALYTICS RESPONSE:", response.data);

//   if (!response.data?.status) {
//     throw new Error(
//       response.data?.message || "Credit bureau verification failed"
//     );
//   }

//   return response.data;
// };
const fetchCreditAnalytics = async () => {
  console.log(
    "========== CREDIT ANALYTICS START =========="
  );

  const stored = getCustomerSession() || {};
  const saved = stored?.saved_fields || {};

  const leadId = String(
    stored?.lead_id ||
    customerLeadId ||
    ""
  ).trim();

  if (!leadId) {
    throw new Error("Lead ID is missing");
  }

  const fullName = String(
    aadhaarProfile?.name ||
    aadhaarProfile?.raw?.name ||
    panProfile?.name ||
    saved?.aadhaar_profile?.name ||
    saved?.pan_profile?.name ||
    ""
  ).trim();

  const nameParts = fullName
    .split(/\s+/)
    .filter(Boolean);

  const firstName = (
    nameParts[0] || ""
  ).toUpperCase();

  const lastName = (
    nameParts.slice(1).join(" ") || ""
  ).toUpperCase();

  console.log(
    "========== NAME FOR CREDIT ANALYTICS =========="
  );

  console.log("FULL NAME:", fullName);
  console.log("FIRST NAME:", firstName);
  console.log("LAST NAME:", lastName);

  const address =
    aadhaarProfile?.address ||
    aadhaarProfile?.raw?.address ||

    "";

  const city =
    aadhaarProfile?.raw?.district ||
    aadhaarProfile?.city ||
    saved?.city ||
    "";

  const state =
    aadhaarProfile?.raw?.state ||
    aadhaarProfile?.state ||
    saved?.state ||
    "";

  const pincode =
    aadhaarProfile?.raw?.pincode ||
    aadhaarProfile?.pincode ||
    saved?.pincode ||
    "";

  const dateOfBirth = (() => {
    const dob = String(
      panProfile?.dob ||
      panProfile?.dateOfBirth ||
      aadhaarProfile?.dob ||
      aadhaarProfile?.raw?.dateOfBirth ||
      saved?.aadhaar_dob ||
      ""
    ).trim();

    if (!dob) return "";

    // YYYY-MM-DD -> DD-MM-YYYY
    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
      const [year, month, day] = dob.split("-");

      return `${day}-${month}-${year}`;
    }

    // DD/MM/YYYY -> DD-MM-YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dob)) {
      return dob.replace(/\//g, "-");
    }

    // DD-MM-YYYY already
    if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) {
      return dob;
    }

    return dob;
  })();

  const mobileNo = String(
    mobile ||
    stored?.customer_mobile ||
    stored?.mobile ||
    ""
  )
    .replace(/\D/g, "")
    .slice(-10);

  if (mobileNo.length !== 10) {
    throw new Error("Valid mobile number is missing");
  }

  const gender =
    panProfile?.gender ||
    aadhaarProfile?.gender ||
    aadhaarProfile?.raw?.gender ||
    saved?.gender ||
    "";

    const formattedAddress = String(address || "")
  .trim()
  .split(/\s+/)
  .slice(0, 3) // sirf starting ke 3 words
  .map((word) => word.slice(0, 40)) // har word max 15 chars
  .join(" ");
  // const formattedAddress = String(address || "")
  // .trim()
  // .slice(0, 35);
  const payload = {
      // lead_id: leadId,
    mobile_no: mobileNo,

    first_name: firstName,

    last_name: lastName,

    pan:
      panProfile?.pan ||
      pan ||
      saved?.pan ||
      "",

    // address:formattedAddress,
        address:state,

    // city: city,
    city:state,

    state: state,

    pincode: pincode,

    date_of_birth: dateOfBirth,

    email:email ||saved?.email ||"",
    gender: gender,
  };

  console.log(
    "========== CREDIT ANALYTICS FINAL PAYLOAD =========="
  );

  console.log(
    JSON.stringify(payload, null, 2)
  );

  console.log(
    "CREDIT ANALYTICS REQUEST:",
    payload
  );

  const response = await axios.post(
    creditAnalyticsUrl(),
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 30000,
      withCredentials: true,
      validateStatus: () => true,
    }
  );

  console.log(
    "========== CREDIT ANALYTICS RESPONSE =========="
  );

  console.log(
    "HTTP STATUS:",
    response.status
  );

  console.log(
    "RESPONSE:",
    response.data
  );

  if (
    response.status < 200 ||
    response.status >= 300 ||
    !response.data?.status
  ) {
    throw new Error(
      response.data?.message ||
      "Credit bureau verification failed"
    );
  }

  return response.data;
};
//jab cha jaye ga adar tab isko hata den ge  
// const fetchCreditAnalytics = async () => {
//   const stored = getCustomerSession() || {};
//   const saved = stored?.saved_fields || {};
//   const aadhaarSession =
//   saved?.aadhaar_profile ||
//   {};

// const city =
//   aadhaarProfile?.city ||
//   aadhaarProfile?.raw?.district ||
//   aadhaarSession?.city ||
//   aadhaarSession?.raw?.district ||
//   saved?.city ||
//   "";

// const state =
//   aadhaarProfile?.state ||
//   aadhaarProfile?.raw?.state ||
//   aadhaarSession?.state ||
//   aadhaarSession?.raw?.state ||
//   saved?.state ||
//   "";

// const pincode =
//   aadhaarProfile?.pincode ||
//   aadhaarProfile?.raw?.pincode ||
//   aadhaarSession?.pincode ||
//   aadhaarSession?.raw?.pincode ||
//   saved?.pincode ||
//   "";

//   const leadId = String(
//     stored?.lead_id ||
//     customerLeadId ||
//     ""
//   ).trim();

//   if (!leadId) {
//     throw new Error("Lead ID is missing");
//   }

//   const payload = {
//     lead_id: leadId,

//     mobile_no: mobile,

//     // Current PAN data first, session fallback
//     first_name:
//       panProfile?.firstName ||
//       saved?.pan_profile?.firstName ||
//       saved?.aadhaar_profile?.firstName ||
//       saved?.aadhaar_first_name ||
//       "",

//     last_name:
//       panProfile?.lastName ||
//       saved?.pan_profile?.lastName ||
//       saved?.aadhaar_profile?.lastName ||
//       saved?.aadhaar_last_name ||
//       "",

//     pan:
//       panProfile?.pan ||
//       pan ||
//       saved?.pan ||
//       saved?.pan_profile?.pan ||
//       "",

//     address:
//       panProfile?.address ||
//       aadhaarProfile?.address ||
//       saved?.pan_profile?.address ||
//       saved?.aadhaar_profile?.address ||
//       saved?.aadhaar_address ||
//       "",

//     // Current Aadhaar data first, session fallback
//     // city:
//     //   aadhaarProfile?.raw?.district ||
//     //   aadhaarProfile?.city ||
//     //   saved?.aadhaar_profile?.raw?.district ||
//     //   saved?.aadhaar_profile?.city ||
//     //   saved?.city ||
//     //   "",

//     // state:
//     //   aadhaarProfile?.raw?.state ||
//     //   aadhaarProfile?.state ||
//     //   saved?.aadhaar_profile?.raw?.state ||
//     //   saved?.aadhaar_profile?.state ||
//     //   saved?.state ||
//     //   "",

//     // pincode:
//     //   aadhaarProfile?.raw?.pincode ||
//     //   aadhaarProfile?.pincode ||
//     //   saved?.aadhaar_profile?.raw?.pincode ||
//     //   saved?.aadhaar_profile?.pincode ||
//     //   saved?.pincode ||
//     //   "",

// city: city,

// state: state,

// pincode: pincode,

//     // Current PAN DOB first, session fallback
//     date_of_birth: (() => {
//       const dob =
//         panProfile?.dob ||
//         saved?.pan_profile?.dob ||
//         saved?.aadhaar_profile?.dob ||
//         saved?.aadhaar_dob ||
//         "";

//       if (!dob) return "";

//       if (dob.includes("/")) {
//         const [day, month, year] = dob.split("/");

//         if (day && month && year) {
//           return `${year}-${month.padStart(2, "0")}-${day.padStart(
//             2,
//             "0"
//           )}`;
//         }
//       }

//       return dob;
//     })(),

//     email:
//       email ||
//       saved?.email ||
//       "",

//     gender:
//       panProfile?.gender ||
//       saved?.pan_profile?.gender ||
//       aadhaarProfile?.gender ||
//       saved?.aadhaar_profile?.gender ||
//       saved?.aadhaar_gender ||
//       "",
//   };

//   console.log(
//     "========== CREDIT ANALYTICS FINAL PAYLOAD =========="
//   );

//   console.log(JSON.stringify(payload, null, 2));

//   console.log("CREDIT ANALYTICS REQUEST:", payload);

//   const response = await axios.post(
//     creditAnalyticsUrl(),
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       timeout: 30000,
//       withCredentials: true,
//       validateStatus: () => true,
//     }
//   );

//   console.log("CREDIT ANALYTICS RESPONSE:", response.data);

//   if (!response.data?.status) {
//     throw new Error(
//       response.data?.message ||
//       "Credit bureau verification failed"
//     );
//   }

//   return response.data;
// };

  // const submitEmployment = async () => {
  //   if (!employment.employer.trim()) {
  //     setEmploymentError("Enter name of employer");
  //     return;
  //   }
  //   // if (!employment.salary || Number(employment.salary) <= 0) {
  //   //   setEmploymentError("Enter a valid monthly salary");
  //   //   return;
  //   // }

  //   if (!employment.salary || Number(employment.salary) < 20000) {
  //     setEmploymentError(
  //       "Net monthly salary must be at least ₹20,000"
  //     );
  //     return;
  //   }

  //   if (!isValidSalaryDate(employment.salaryDate)) {
  //     setEmploymentError("Select a valid salary date (DDMMYY)");
  //     return;
  //   }
  //   if (!employment.loanAmount || Number(employment.loanAmount) <= 0) {
  //     setEmploymentError("Enter a valid loan amount");
  //     return;
  //   }
  //   if (!employment.loanPurpose) {
  //     setEmploymentError("Select loan purpose");
  //     return;
  //   }
  //   if (!employment.employmentType) {
  //     setEmploymentError("Select employment type");
  //     return;
  //   }
  //   if (!employment.salaryMode) {
  //     setEmploymentError("Select mode of income");
  //     return;
  //   }

  //   setEmploymentError("");
  //   await saveCustomerProgress(3);
  //   await saveEnquiryProgress("employment_completed", {
  //     mobile_verified: 1,

  //     employer: employment.employer,
  //     monthly_income: employment.salary,
  //     salary_date: employment.salaryDate,
  //     loan_amount: employment.loanAmount,
  //     loan_purpose: employment.loanPurpose,
  //     employment_type: employment.employmentType,
  //     salary_mode: employment.salaryMode,
  //   });
  //   navigate("/apply-new/processBank");
  // };

// const runBureauMobileBRE = async (creditResponse) => {
//   console.log("========== BUREAU MOBILE BRE START ==========");

  
//   const leadId = "LEAD001";
//   const userId = "USER561";
//   const appUserId = "APPUSER561";

//   // Employment Details se actual salary
// // Employment Details se actual salary
// const declaredIncome = Number(
//   String(employment.salary || "").replace(/,/g, "")
// );

//   if (!leadId) {
//     throw new Error("Lead ID is missing");
//   }

//   if (!declaredIncome) {
//     throw new Error("Declared income is missing");
//   }

//   /*
//    * Credit Bureau response se CRIF data
//    */
//   const resultJson =
//     creditResponse?.data?.result_json ||
//     creditResponse?.result_json ||
//     creditResponse?.data?.crif_data?.result_json ||
//     creditResponse?.crif_data?.result_json ||
//     null;

//   if (!resultJson) {
//     console.error(
//       "CREDIT RESPONSE FOR MOBILE BRE:",
//       creditResponse
//     );

//     throw new Error(
//       "CRIF data is missing from Credit Bureau response"
//     );
//   }

//   const payload = {
//   user_id: userId,

//   // TEMPORARY
//   reference_id: leadId,

//   input_data: {
//     lead_id: leadId,
//     app_user_id: appUserId,

//     // Employment Details
//     declared_income: declaredIncome,
//     employer: employment.employer || "",
//     employer_name: employment.employer || "",
//     monthly_income: declaredIncome,
//     salary: declaredIncome,
//     salary_date: employment.salaryDate || "",
//     loan_amount: employment.loanAmount || "",
//     loan_purpose: employment.loanPurpose || "",
//     employment_type: employment.employmentType || "",
//     salary_mode: employment.salaryMode || "",

//     // Credit Bureau ka actual CRIF result
//     crif_data: {
//       result_json: resultJson,
//     },
//   },
// };
//   console.log(
//     "========== BUREAU MOBILE BRE PAYLOAD =========="
//   );

//   console.log(
//     JSON.stringify(payload, null, 2)
//   );

//   const response = await axios.post(
//     bureauMobileBreUrl(),
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       timeout: 30000,
//       withCredentials: true,
//       validateStatus: () => true,
//     }
//   );

//   console.log(
//     "========== BUREAU MOBILE BRE RESPONSE =========="
//   );

//   console.log(
//     JSON.stringify(response.data, null, 2)
//   );

//   if (!response.data?.status) {
//     throw new Error(
//       response.data?.message ||
//         "Bureau Mobile BRE verification failed"
//     );
//   }

//   return response.data;
// };

const runBureauMobileBRE = async (creditResponse) => {
  console.log("========== BUREAU MOBILE BRE START ==========");
const stored = getCustomerSession() || {};

  // const leadId = "LEAD001";
  const leadId = String(stored?.lead_id ||customerLeadId ||"").trim();
  // const userId = "USER561";
  // const appUserId = "APPUSER561";

  console.log("Lead ID:", leadId);

  const declaredIncome = Number(
    String(employment?.salary || "")
      .replace(/,/g, "")
      .trim()
  );
  const loanAmount = Number(
  String(stored?.loan_amount || "")
    .replace(/,/g, "")
    .trim()
);

  console.log("Declared Income:", declaredIncome);

  if (!declaredIncome || declaredIncome <= 0) {
    throw new Error("Declared income is missing");
  }

  console.log(
    "========== CREDIT RESPONSE RECEIVED =========="
  );

  console.log(
    JSON.stringify(creditResponse, null, 2)
  );

  if (creditResponse?.status !== true) {
    throw new Error(
      creditResponse?.message ||
      "Credit Bureau verification was not successful"
    );
  }

  const crifData =
    creditResponse?.crif_data ||
    creditResponse?.data?.crif_data ||
    null;

  console.log(
    "========== CRIF DATA =========="
  );

  console.log(
    JSON.stringify(crifData, null, 2)
  );

  if (
    !crifData ||
    typeof crifData !== "object" ||
    Object.keys(crifData).length === 0
  ) {
    throw new Error(
      "CRIF data is missing from Credit Bureau response"
    );
  }

  const payload = {
    // user_id: userId,

    // reference_id: leadId,

    input_data: {
      lead_id: leadId,

      // app_user_id: appUserId,

      declared_income: declaredIncome,
       loan_amount: loanAmount,
  
      crif_data: crifData
    }
  };

  console.log(
    "========== BUREAU MOBILE BRE PAYLOAD =========="
  );

  console.log(
    JSON.stringify(payload, null, 2)
  );

  const response = await axios.post(
    bureauMobileBreUrl(),
    payload,
    {
      headers: {
        "Content-Type": "application/json"
      },

      timeout: 120000,

      withCredentials: true,

      validateStatus: () => true
    }
  );

  console.log(
    "========== BUREAU MOBILE BRE RESPONSE =========="
  );

  console.log(
    JSON.stringify(response.data, null, 2)
  );

  if (!response.data?.status) {

    throw new Error(
      response.data?.message ||
      response.data?.error?.message ||
      "Bureau Mobile BRE verification failed"
    );
  }

  console.log(
    "========== BUREAU MOBILE BRE SUCCESS =========="
  );

  console.log(
    "Decision:",
    response.data?.decision
  );

  console.log(
    "Bureau Score:",
    response.data?.bureau_score
  );

  console.log(
    "Risk Grade:",
    response.data?.cbs_risk_grade
  );

  return response.data;
};
const submitEmployment = async () => {
  setEmploymentError("");

  if (!employment.employer?.trim()) {
    setEmploymentError("Please enter employer name");
    return;
  }

  const salaryAmount = Number(
    String(employment.salary || "").replace(/,/g, "")
  );

  if (!salaryAmount || salaryAmount < 20000) {
    setEmploymentError("Minimum monthly salary should be ₹20,000");
    return;
  }

  if (!employment.salaryDate) {
    setEmploymentError("Please select salary date");
    return;
  }

  if (!employment.loanAmount) {
    setEmploymentError("Please select loan amount");
    return;
  }

  if (!employment.loanPurpose) {
    setEmploymentError("Please select loan purpose");
    return;
  }

  if (!employment.employmentType) {
    setEmploymentError("Please select employment type");
    return;
  }

  if (!employment.salaryMode) {
    setEmploymentError("Please select salary mode");
    return;
  }

  try {

    await saveCustomerProgress(3);


    await saveEnquiryProgress("employment_completed", {
      employer: employment.employer,
      employer_name: employment.employer,

      monthly_income: salaryAmount,
      salary: salaryAmount,

      salary_date: employment.salaryDate,

      loan_amount: employment.loanAmount,
      loan_purpose: employment.loanPurpose,

      employment_type: employment.employmentType,
      salary_mode: employment.salaryMode,
    });

    // ---------------------------------------
    // 4. GO TO CREDIT PROCESSING SCREEN
    // ---------------------------------------

    navigate("/apply-new/processBank");

  } catch (error) {
    console.error("Employment submission error:", error);

    setEmploymentError(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to save employment details. Please try again."
    );
  }
};

// const runCreditAnalytics = async () => {
//   console.log("========== CREDIT ANALYTICS START ==========");

//   const creditResponse = await fetchCreditAnalytics();

//   console.log(
//     "========== CREDIT ANALYTICS RESPONSE ==========",
//     creditResponse
//   );

//   if (!creditResponse?.status) {
//     throw new Error(
//       creditResponse?.message ||
//         "Credit bureau verification failed"
//     );
//   }

//   mergeCustomerSession({
//     creditAnalytics: creditResponse,
//     credit_client_ref_num:
//       creditResponse?.client_ref_num || "",
//     credit_result_code:
//       creditResponse?.result_code || "",
//     credit_verified: "1",
//   });

//   return creditResponse;
// };
  
const runCreditAnalytics = async () => {
  console.log("========== CREDIT BUREAU START ==========");

  const creditResponse = await fetchCreditAnalytics();

  console.log(
    "========== CREDIT BUREAU RESPONSE ==========",
    creditResponse
  );

  if (!creditResponse?.status) {
    throw new Error(
      creditResponse?.message ||
        "Credit bureau verification failed"
    );
  }

  mergeCustomerSession({
    creditAnalytics: creditResponse,

    credit_client_ref_num:
      creditResponse?.client_ref_num || "",

    credit_result_code:
      creditResponse?.result_code || "",

    credit_verified: "1",
  });

  console.log(
    "========== CREDIT BUREAU SUCCESS =========="
  );

  console.log(
    "========== STARTING BUREAU MOBILE BRE =========="
  );

  const mobileBreResponse =
    await runBureauMobileBRE(creditResponse);

  console.log(
    "========== BUREAU MOBILE BRE SUCCESS ==========",
    mobileBreResponse
  );

  if (!mobileBreResponse?.status) {
    throw new Error(
      mobileBreResponse?.message ||
        "Bureau Mobile BRE verification failed"
    );
  }

  const mobileBreDecision = String(
  mobileBreResponse?.final_decision?.Decision || ""
).trim();

const mobileBreReason =
  mobileBreResponse?.final_decision?.DecisionReason || "";

console.log(
  "========== MOBILE BRE DECISION =========="
);

console.log("DECISION:", mobileBreDecision);
console.log("REASON:", mobileBreReason);

// if (mobileBreDecision.toLowerCase() === "reject") {
//   console.log(
//     "========== MOBILE BRE REJECT =========="
//   );

//   mergeCustomerSession({
//     bureauMobileBre: mobileBreResponse,
//     bureau_mobile_bre_verified: "1",
//     mobile_bre_decision: mobileBreDecision,
//     mobile_bre_decision_reason: mobileBreReason,
//   });

//   navigate("/apply-new/mobileBreReject");

//   return {
//     creditResponse,
//     mobileBreResponse,
//     rejected: true,
//   };
// }

if (mobileBreDecision.toLowerCase() === "reject") {
  console.log(
    "========== MOBILE BRE REJECT =========="
  );

  mergeCustomerSession({
    bureauMobileBre: mobileBreResponse,
    bureau_mobile_bre_verified: "1",
    mobile_bre_decision: mobileBreDecision,
    mobile_bre_decision_reason: mobileBreReason,
  });

  console.log(
    "========== MOBILE BRE REJECT - GOING TO PROCESS BANK =========="
  );

  navigate("/apply-new/processBank");

  return {
    creditResponse,
    mobileBreResponse,
    rejected: true,
  };
}

  mergeCustomerSession({
    bureauMobileBre: mobileBreResponse,
    bureau_mobile_bre_verified: "1",
  });

  console.log(
    "========== CREDIT + MOBILE BRE COMPLETED =========="
  );

  return {
    creditResponse,
    mobileBreResponse,
  };
};
//main
// const handleProceedToBank = async () => {
//   try {
//     console.log("========== ACCOUNT AGGREGATOR START ==========");

//     // TEMPORARY TESTING
//     const leadId = "LEAD001";

//     const mobileNum = String(
//       mobile || getCustomerSession()?.customer_mobile || ""
//     )
//       .replace(/\D/g, "")
//       .slice(-10);

//     if (!leadId) {
//       throw new Error("Lead ID is missing");
//     }

//     if (mobileNum.length !== 10) {
//       throw new Error("Valid mobile number is missing");
//     }

//     const payload = {
//       lead_id: leadId,
//       mobile_num: mobileNum,
//     };

//     console.log(
//       "========== ACCOUNT AGGREGATOR REQUEST =========="
//     );

//     console.log(
//       "AA PAYLOAD:",
//       JSON.stringify(payload, null, 2)
//     );

//     const response = await axios.post(
//       generateAccountAggregatorUrl(),
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         timeout: 30000,
//         withCredentials: true,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "========== ACCOUNT AGGREGATOR RESPONSE =========="
//     );

//     console.log(
//       "AA RESPONSE:",
//       response.data
//     );

//     if (!response.data?.status) {
//       throw new Error(
//         response.data?.message ||
//           "Unable to start bank verification"
//       );
//     }

//     const aaUrl = response.data?.url;

//     if (!aaUrl) {
//       throw new Error(
//         "Account Aggregator URL not received"
//       );
//     }

//     mergeCustomerSession({
//       aa_request_id: String(
//         response.data?.request_id || ""
//       ),
//       aa_client_ref_num:
//         response.data?.client_ref_num || "",
//       aa_url: aaUrl,
//       aa_expires:
//         response.data?.expires || "",
//     });


//     console.log(
//       "========== OPENING ACCOUNT AGGREGATOR URL =========="
//     );


//     console.log("AA URL:", aaUrl);

//     // Open Digitap Account Aggregator dashboard
//     window.open(
//       aaUrl,
//       "_blank",
//       "noopener,noreferrer"
//     );

//   } catch (error) {
//     console.error(
//       "========== ACCOUNT AGGREGATOR ERROR ==========",
//       error
//     );

//     alert(
//       error?.response?.data?.message ||
//         error?.message ||
//         "Unable to start bank verification"
//     );
//   }
// };
//main
// const checkAAStatus = async (requestId) => {
//   try {
//     console.log(
//       "========== ACCOUNT AGGREGATOR STATUS CHECK =========="
//     );

//     if (!requestId) {
//       throw new Error("Account Aggregator request ID is missing");
//     }

//     const payload = {
//       request_id: String(requestId),
//     };

//     console.log(
//       "AA STATUS PAYLOAD:",
//       JSON.stringify(payload, null, 2)
//     );

//     const response = await axios.post(
//       checkAccountAggregatorStatus(),
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         timeout: 30000,
//         withCredentials: true,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "========== ACCOUNT AGGREGATOR STATUS RESPONSE =========="
//     );

//     console.log("AA STATUS HTTP:", response.status);
//     console.log("AA STATUS RESPONSE:", response.data);

//     if (!response.data?.status) {
//       throw new Error(
//         response.data?.message ||
//           "Unable to check Account Aggregator status"
//       );
//     }

//     return response.data;

//   } catch (error) {
//     console.error(
//       "========== ACCOUNT AGGREGATOR STATUS ERROR ==========",
//       error
//     );

//     console.error(
//       "AA STATUS ERROR RESPONSE:",
//       error?.response?.data
//     );

//     throw new Error(
//       error?.response?.data?.message ||
//         error?.message ||
//         "Unable to check Account Aggregator status"
//     );
//   }
// };

const checkAAStatus = async (requestId) => {
  try {
    console.log(
      "========== ACCOUNT AGGREGATOR STATUS CHECK =========="
    );

    if (!requestId) {
      throw new Error(
        "Account Aggregator request ID is missing"
      );
    }

    const payload = {
      request_id: String(requestId),
    };

    console.log(
      "AA STATUS PAYLOAD:",
      JSON.stringify(payload, null, 2)
    );

    const response =
     await axios.post(
    "https://fundswalla.in/Api/TaskApi/checkAccountAggregatorStatus",
      payload,  
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 30000,
        withCredentials: true,
        validateStatus: () => true,
      }
    );

    console.log(
      "========== ACCOUNT AGGREGATOR STATUS RESPONSE =========="
    );

    console.log(
      "AA STATUS HTTP:",
      response.status
    );

    console.log(
      "AA STATUS RESPONSE:",
      response.data
    );

    if (!response.data?.status) {
      throw new Error(
        response.data?.message ||
          "Unable to check Account Aggregator status"
      );
    }

    return response.data;

  } catch (error) {
    console.error(
      "========== ACCOUNT AGGREGATOR STATUS ERROR ==========",
      error
    );

    console.error(
      "AA STATUS ERROR RESPONSE:",
      error?.response?.data
    );

    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to check Account Aggregator status"
    );
  }
};
// test 1 all run right 
// const handleProceedToBank = async () => {
//   try {
//     console.log(
//       "========== ACCOUNT AGGREGATOR START =========="
//     );

//     // TEMPORARY TESTING
//     const leadId = "LEAD001";

//     // Mobile existing application/API data se
//     const stored = getCustomerSession() || {};

//     const mobileNum = String(
//       mobile ||
//       stored.customer_mobile ||
//       stored.mobile ||
//       stored.Mobile ||
//       ""
//     )
//       .replace(/\D/g, "")
//       .slice(-10);

//     console.log("AA TEST LEAD ID:", leadId);
//     console.log("AA MOBILE FROM DATA:", mobileNum);

//     if (!leadId) {
//       throw new Error("Lead ID is missing");
//     }

//     if (mobileNum.length !== 10) {
//       throw new Error("Valid mobile number is missing");
//     }

//     const payload = {
//       lead_id: leadId,
//       mobile_num: mobileNum,
//     };

//     console.log(
//       "========== ACCOUNT AGGREGATOR REQUEST =========="
//     );

//     console.log(
//       "AA PAYLOAD:",
//       JSON.stringify(payload, null, 2)
//     );

//     // ==========================================
//     // 1. GENERATE AA URL
//     // ==========================================

//     const response = await axios.post(
//       generateAccountAggregatorUrl(),
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         timeout: 30000,
//         withCredentials: true,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "========== ACCOUNT AGGREGATOR RESPONSE =========="
//     );

//     console.log("AA STATUS:", response.status);
//     console.log("AA RESPONSE:", response.data);

//     if (!response.data?.status) {
//       throw new Error(
//         response.data?.message ||
//           "Unable to start bank verification"
//       );
//     }

//     // ==========================================
//     // 2. GET AA URL
//     // ==========================================

//     const aaUrl = response.data?.url;

//     if (!aaUrl) {
//       throw new Error(
//         "Account Aggregator URL not received"
//       );
//     }

//     // ==========================================
//     // 3. GET REQUEST ID
//     // ==========================================

//     const requestId = String(
//       response.data?.request_id || ""
//     );

//     console.log(
//       "AA REQUEST ID:",
//       requestId
//     );

//     if (!requestId) {
//       throw new Error(
//         "Account Aggregator request ID not received"
//       );
//     }

//     // ==========================================
//     // 4. SAVE AA DETAILS
//     // ==========================================

//     mergeCustomerSession({
//       aa_request_id: requestId,

//       aa_client_ref_num:
//         response.data?.client_ref_num || "",

//       aa_url: aaUrl,

//       aa_expires:
//         response.data?.expires || "",
//     });

//     console.log(
//       "========== AA DETAILS SAVED =========="
//     );

//     // ==========================================
//     // 5. OPEN AA URL
//     // ==========================================

//     console.log(
//       "========== OPENING ACCOUNT AGGREGATOR URL =========="
//     );

//     console.log("AA URL:", aaUrl);

//     window.open(
//       aaUrl,
//       "_blank",
//       "noopener,noreferrer"
//     );

//     console.log(
//       "========== AA URL OPENED =========="
//     );

//     // ==========================================
//     // 6. TEMPORARY STATUS CHECK
//     // ==========================================

//     console.log(
//       "========== TEMPORARY AA STATUS CHECK =========="
//     );

//     console.log(
//       "Status check will run after 2 seconds"
//     );

//     setTimeout(async () => {
//       try {
//         console.log(
//           "========== CHECKING AA STATUS =========="
//         );

//         console.log(
//           "AA REQUEST ID FOR STATUS:",
//           requestId
//         );

//         const statusResponse =
//           await checkAAStatus(requestId);

//         console.log(
//           "========== AA STATUS CHECK COMPLETED =========="
//         );

//         console.log(
//           "AA STATUS RESPONSE:",
//           statusResponse
//         );

//       } catch (statusError) {
//         console.error(
//           "========== AA STATUS CHECK ERROR ==========",
//           statusError
//         );

//         console.error(
//           "AA STATUS ERROR RESPONSE:",
//           statusError?.response?.data
//         );
//       }
//     }, 2000);

//   } catch (error) {
//     console.error(
//       "========== ACCOUNT AGGREGATOR ERROR ==========",
//       error
//     );

//     console.error(
//       "AA ERROR RESPONSE:",
//       error?.response?.data
//     );

//     alert(
//       error?.response?.data?.message ||
//         error?.message ||
//         "Unable to start bank verification"
//     );
//   }
// };
//test2
// const handleProceedToBank = async () => {
//   try {
//     console.log(
//       "========== ACCOUNT AGGREGATOR START =========="
//     );

//     // TEMPORARY TESTING
//     const leadId = "LEAD001";

//     // Mobile existing application/API data se
//     const stored = getCustomerSession() || {};

//     const mobileNum = String(
//       mobile ||
//       stored.customer_mobile ||
//       stored.mobile ||
//       stored.Mobile ||
//       ""
//     )
//       .replace(/\D/g, "")
//       .slice(-10);

//     console.log("AA TEST LEAD ID:", leadId);
//     console.log("AA MOBILE FROM DATA:", mobileNum);

//     if (!leadId) {
//       throw new Error("Lead ID is missing");
//     }

//     if (mobileNum.length !== 10) {
//       throw new Error("Valid mobile number is missing");
//     }

//     const payload = {
//       lead_id: leadId,
//       mobile_num: mobileNum,
//     };

//     console.log(
//       "========== ACCOUNT AGGREGATOR REQUEST =========="
//     );

//     console.log(
//       "AA PAYLOAD:",
//       JSON.stringify(payload, null, 2)
//     );

//     // ==========================================
//     // 1. GENERATE ACCOUNT AGGREGATOR URL
//     // ==========================================

//     const response = await axios.post(
//       generateAccountAggregatorUrl(),
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         timeout: 30000,
//         withCredentials: true,
//         validateStatus: () => true,
//       }
//     );

//     console.log(
//       "========== ACCOUNT AGGREGATOR RESPONSE =========="
//     );

//     console.log("AA STATUS:", response.status);
//     console.log("AA RESPONSE:", response.data);

//     if (!response.data?.status) {
//       throw new Error(
//         response.data?.message ||
//           "Unable to start bank verification"
//       );
//     }

//     // ==========================================
//     // 2. GET AA URL
//     // ==========================================

//     const aaUrl = response.data?.url;

//     if (!aaUrl) {
//       throw new Error(
//         "Account Aggregator URL not received"
//       );
//     }

//     // ==========================================
//     // 3. GET REQUEST ID
//     // ==========================================

//     const requestId = String(
//       response.data?.request_id || ""
//     );

//     console.log(
//       "AA REQUEST ID:",
//       requestId
//     );

//     if (!requestId) {
//       throw new Error(
//         "Account Aggregator request ID not received"
//       );
//     }

//     // ==========================================
//     // 4. SAVE AA DETAILS
//     // ==========================================

//     mergeCustomerSession({
//       aa_request_id: requestId,

//       aa_client_ref_num:
//         response.data?.client_ref_num || "",

//       aa_url: aaUrl,

//       aa_expires:
//         response.data?.expires || "",
//     });

//     console.log(
//       "========== AA DETAILS SAVED =========="
//     );

//     console.log("AA REQUEST ID:", requestId);
//     console.log("AA URL:", aaUrl);
//     console.log(
//       "AA EXPIRES:",
//       response.data?.expires
//     );

//     // ==========================================
//     // 5. OPEN ACCOUNT AGGREGATOR URL
//     // ==========================================

//     console.log(
//       "========== OPENING ACCOUNT AGGREGATOR URL =========="
//     );

//     console.log("AA URL:", aaUrl);

//     window.open(
//       aaUrl,
//       "_blank",
//       "noopener,noreferrer"
//     );

//     // ==========================================
//     // IMPORTANT
//     // ==========================================
//     // DO NOT call checkAAStatus() here.
//     //
//     // User must first complete the Account
//     // Aggregator flow in the newly opened tab.
//     //
//     // Status API will be called AFTER the
//     // Account Aggregator flow is completed.
//     // ==========================================

//   } catch (error) {
//     console.error(
//       "========== ACCOUNT AGGREGATOR ERROR ==========",
//       error
//     );

//     console.error(
//       "AA ERROR RESPONSE:",
//       error?.response?.data
//     );

//     alert(
//       error?.response?.data?.message ||
//         error?.message ||
//         "Unable to start bank verification"
//     );
//   }
// };
//test 3

//running properly but comment to test new thi in date 02 sept
const handleProceedToBank = async () => {
  try {
    console.log(
      "========== ACCOUNT AGGREGATOR START =========="
    );


  const stored = getCustomerSession() || {};

const leadId = String(
  stored?.lead_id ||
  customerLeadId ||
  ""
).trim();

    const mobileNum = String(
      mobile ||
        stored.customer_mobile ||
        stored.mobile ||
        stored.Mobile ||
        ""
    )
      .replace(/\D/g, "")
      .slice(-10);

    console.log(
      "AA TEST LEAD ID:",
      leadId
    );

    console.log(
      "AA MOBILE FROM DATA:",
      mobileNum
    );

    if (!leadId) {
      throw new Error("Lead ID is missing");
    }

    if (mobileNum.length !== 10) {
      throw new Error(
        "Valid mobile number is missing"
      );
    }

    // ==========================================
    // 3. GENERATE AA URL
    // ==========================================

    const payload = {
      lead_id: leadId,
      mobile_num: mobileNum,
    };

    console.log(
      "========== ACCOUNT AGGREGATOR REQUEST =========="
    );

    console.log(
      "AA PAYLOAD:",
      JSON.stringify(payload, null, 2)
    );

    const response = await axios.post(
      generateAccountAggregatorUrl(),
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 30000,
        withCredentials: true,
        validateStatus: () => true,
      }
    );

    console.log(
      "========== ACCOUNT AGGREGATOR RESPONSE =========="
    );

    console.log(
      "AA HTTP STATUS:",
      response.status
    );

    console.log(
      "AA RESPONSE:",
      response.data
    );

    if (!response.data?.status) {
      throw new Error(
        response.data?.message ||
          "Unable to start bank verification"
      );
    }

    const aaUrl = response.data?.url;

    if (!aaUrl) {
      throw new Error(
        "Account Aggregator URL not received"
      );
    }


    const requestId = String(
      response.data?.request_id || ""
    ).trim();

    console.log(
      "AA REQUEST ID:",
      requestId
    );

    if (!requestId) {
      throw new Error(
        "Account Aggregator request ID not received"
      );
    }


    // mergeCustomerSession({
    //   aa_request_id: requestId,

    //   aa_client_ref_num:
    //     response.data?.client_ref_num || "",

    //   aa_url: aaUrl,

    //   aa_expires:
    //     response.data?.expires || "",
    // });


mergeCustomerSession({
  aa_request_id: requestId,

  aa_lead_id:
    response.data?.lead_id || leadId,

  aa_mobile_num:
    response.data?.mobile_num || mobileNum,

  aa_client_ref_num:
    response.data?.client_ref_num || "",

  aa_url: aaUrl,

  aa_expires:
    response.data?.expires || "",
});
    console.log(
      "========== AA DETAILS SAVED =========="
    );

    console.log(
      "AA REQUEST ID:",
      requestId
    );

    console.log(
      "AA URL:",
      aaUrl
    );

    console.log(
      "AA EXPIRES:",
      response.data?.expires || ""
    );


    console.log(
      "========== OPENING ACCOUNT AGGREGATOR URL =========="
    );

    console.log(
      "AA URL:",
      aaUrl
    );

    // window.open(
    //   aaUrl,
    //   "_blank",
    //   "noopener,noreferrer"
    // );
    const aaWindow = window.open(
  aaUrl,
  "_blank"
);

if (!aaWindow) {
  throw new Error(
    "Unable to open Account Aggregator window. Please allow popups."
  );
}

console.log("========== AA TAB OPENED ==========");

    console.log(
      "========== AA URL OPENED =========="
    );

    //
    // DEMO CALLBACK REMOVED
    //
    // Abhi flow:
    //
    // Generate URL
    //      ↓
    // request_id save
    //      ↓
    // Open Digitap
    //      ↓
    // User completes AA
    //      ↓
    // REAL CALLBACK
    //      ↓
    // Status API
    //      ↓
    // Retrieve Report
    //

  } catch (error) {
    console.error(
      "========== ACCOUNT AGGREGATOR ERROR ==========",
      error
    );

    console.error(
      "AA ERROR RESPONSE:",
      error?.response?.data
    );

    alert(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to start bank verification"
    );
  }
};

const otpValue = otpDigits.join("");
  const aaOtpValue = aaOtpDigits.join("");

  const getLeadPayload = (overrides = {}) => {
    const stored = getCustomerSession() || {};
    const fields = stored.saved_fields || {};
    const storedLoc = readStoredLocation();
    const storedPanProfile = parseStoredJson(fields.pan_profile) || panProfile;
    const storedAadhaarSaved = parseStoredJson(fields.aadhaar_profile);
    const storedAadhaarProfile = {
      ...(storedAadhaarSaved || {}),
      ...(aadhaarProfile || {}),
      raw: {
        ...(storedAadhaarSaved?.raw || {}),
        ...(aadhaarProfile?.raw || {}),
      },
      dob:
        aadhaarProfile?.dob ||
        storedAadhaarSaved?.dob ||
        fields.aadhaar_dob ||
        "",
      dobRaw:
        aadhaarProfile?.dobRaw ||
        storedAadhaarSaved?.dobRaw ||
        fields.aadhaar_dob ||
        "",
      gender:
        aadhaarProfile?.gender ||
        storedAadhaarSaved?.gender ||
        fields.aadhaar_gender ||
        "",
    };
    const storedBank = parseStoredJson(fields.disburse_bank) || disburseBank;
    const storedRefs = parseStoredJson(fields.references) || references;

    return buildLeadApplicationPayload({
      mobile: mobile || stored.customer_mobile,
      email: email || fields.email || fields.email_personal,
      pan: pan || fields.pan,
      panProfile: storedPanProfile,
      aadhaarNumber:
        getAadhaarNumberSecure() || aadhaarNumber || fields.aadhaar_number,
      aadhaarProfile: storedAadhaarProfile,
      aadhaarReference: getAadhaarReferenceSecure(),
      locationCoords: {
        latitude:
          locationCoords.latitude || fields.latitude || storedLoc.latitude,
        longitude:
          locationCoords.longitude || fields.longitude || storedLoc.longitude,
        coordinates:
          locationCoords.coordinates ||
          fields.coordinates ||
          storedLoc.coordinates,
      },
      employment: {
        employer: employment.employer || fields.employer || fields.employer_name,
        salary: employment.salary || fields.monthly_income || fields.salary,
        salaryDate: employment.salaryDate || fields.salary_date,
        loanAmount: employment.loanAmount || fields.loan_amount,
        loanPurpose: employment.loanPurpose || fields.loan_purpose,
        employmentType: employment.employmentType || fields.employment_type,
        salaryMode: employment.salaryMode || fields.salary_mode,
      },
      references: Array.isArray(storedRefs) && storedRefs.length ? storedRefs : references,
      disburseBank: {
        bankName: disburseBank.bankName || storedBank?.bankName || "",
        holderName: disburseBank.holderName || storedBank?.holderName || "",
        accountNumber: disburseBank.accountNumber || storedBank?.accountNumber || "",
        ifsc: disburseBank.ifsc || storedBank?.ifsc || "",
      },
      customerBankingId: customerBankingId || fields.cust_banking_id,
      customerLeadId: customerLeadId || stored.lead_id,
      customerStep,
      selfiePhoto: overrides.selfiePhoto || selfiePhoto,
      consent: true,
      aadhaarConsent: aadhaarConsent || Boolean(storedAadhaarProfile),
      aaMobile,
      selectedBankId,
    });
  };

  const submitLeadAndContinue = async (photoOverride) => {
    if (leadSubmitting) return;

    if (leadSubmittedRef.current && customerLeadId) {
      // navigate("/apply-new/selfieSuccess");
      navigate("/apply-new/sectionLetter");
      return;
    }

    const photo =
      (typeof photoOverride === "string" && photoOverride) || selfiePhoto;
    if (photo) {
      setSelfiePhoto(photo);
      persistSelfie(photo);
    }

    setLeadSubmitError("");
    setLeadSubmitting(true);
    navigate("/apply-new/leadSubmitting");

    try {
      const result = await submitLeadApplication(
        LEAD_APPLICATION_URL,
        getLeadPayload({ selfiePhoto: photo })
      );

      if (!result.ok) {
        setLeadSubmitError(
          result.message || "Application could not be submitted. Please try again."
        );
        navigate("/apply-new/leadSubmitFail");
        return;
      }

      if (result.leadId) setCustomerLeadId(result.leadId);
      leadSubmittedRef.current = true;
      mergeCustomerSession({
        customer_mobile: mobile,
        last_screen: "selfieSuccess",
        lead_id: result.leadId || customerLeadId,
        saved_fields: {
          ...(getCustomerSession()?.saved_fields || {}),
          lead_submitted: "1",
          last_screen: "selfieSuccess",
        },
      });
      navigate("/apply-new/selfieSuccess");
      // navigate("/apply-new/sectionLetter");
    } catch (err) {
      const errors = err?.response?.data?.errors;
      const apiMessage =
        err?.response?.data?.message ||
        (errors && typeof errors === "object"
          ? Object.values(errors).filter(Boolean).join(" ")
          : "");
      setLeadSubmitError(
        apiMessage ||
        (err?.message === "Network Error"
          ? "Could not reach the server. Please try again."
          : "Application could not be submitted. Please try again.")
      );
      navigate("/apply-new/leadSubmitFail");
    } finally {
      setLeadSubmitting(false);
    }
  };

  leadPayloadRef.current = getLeadPayload();

  if (sessionBooting) {
    return (
      <div className="fw-apply">
        <div className="fw-apply__phone">
          <section className="fw-screen fw-screen--plain fw-fade">
            <p className="fw-sub fw-resume-loading">Restoring your application...</p>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="fw-apply">
      <div className="fw-apply__phone">

        {screen === "landing" && (
          <LandingPage openSheet={openSheet} />
        )}

        {screen === "location" && (
          <LocationPage
            locationError={locationError}
            requestLocation={requestLocation}
            locationLoading={locationLoading}
          />
        )}

        {screen === "details" && (
          <PanVerificationPage
            pan={pan}
            setPan={setPan}
            panError={panError}
            setPanError={setPanError}
            panStatus={panStatus}
            setPanStatus={setPanStatus}
            panChecking={panChecking}
            setPanProfile={setPanProfile}
            lastFetchedPanRef={lastFetchedPanRef}
            checkPanOnEnter={checkPanOnEnter}
            email={email}
            setEmail={setEmail}
            emailError={emailError}
            setEmailError={setEmailError}
            checkEligibility={checkEligibility}
            checking={checking}
            setScreen={navigate}
          />
        )}

        {screen === "employment" && (
          <EmploymentPage
            employment={employment}
            updateEmployment={updateEmployment}
            employmentError={employmentError}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            LOAN_PURPOSES={LOAN_PURPOSES}
            EMPLOYMENT_TYPES={EMPLOYMENT_TYPES}
            SALARY_MODES={SALARY_MODES}
            FwDayCalendar={FwDayCalendar}
            FwDropdown={FwDropdown}
            setScreen={navigate}
            submitEmployment={submitEmployment}
          />
        )}

        {screen === "processing" && (
          <ProcessingPage
            setScreen={navigate}
          />
        )}
{screen === "aaCallback" && (
  <AACallbackPage
    setScreen={navigate}
  />
)}
        {screen === "approved" && (
          <ApprovedPage
            employment={employment}
            setActiveReferenceTab={setActiveReferenceTab}
            setReferenceError={setReferenceError}
            setScreen={navigate}
          />
        )}
        {screen === "mobileBreReject" && (
  <MobileBreRejectPage
    setScreen={navigate}
  />
)}

        {screen === "offer" && (
          <OfferPage
            employment={employment}
            offerSeconds={offerSeconds}
            setAddBankSource={setAddBankSource}
            setDisburseBankError={
              setDisburseBankError
            }
            setDisburseBankSuccess={
              setDisburseBankSuccess
            }
            setDisburseBank={
              setDisburseBank
            }
            setScreen={navigate}
            panProfile={panProfile}
            getBank={getBank}
            selectedBankId={selectedBankId}
            formatLoanAmount={formatLoanAmount}
            formatCountdown={formatCountdown}
            OfferHeroArt={OfferHeroArt}
          />
        )}

        {screen === "addBankDetails" && (
          <AddBankDetailsPage
            disburseBank={disburseBank}
            updateDisburseBank={updateDisburseBank}
            ALL_BANKS={ALL_BANKS}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            disburseBankError={disburseBankError}
            disburseBankSuccess={disburseBankSuccess}
            disburseBankVerifying={disburseBankVerifying}
            submitDisburseBank={submitDisburseBank}
            addBankSource={addBankSource}
            setScreen={navigate}
          />
        )}

        {screen === "emandate" && (
          <EMandatePage
            onContinue={proceedAfterBankVerification}
            setScreen={navigate}
          />
        )}
        {screen === "processBank" && (
          <ProcessingPage
            setScreen={navigate}
                onProcess={runCreditAnalytics}
                  onProceedToBank={handleProceedToBank}
          />
        )}

        {screen === "selectBank" && (
          <BankSelectionPage
            bankSearch={bankSearch}
            setBankSearch={setBankSearch}

            POPULAR_BANKS={POPULAR_BANKS}
            filteredBanks={filteredBanks}

            setSelectedBankId={setSelectedBankId}
            setScreen={navigate}
          />
        )}

        {screen === "connectBank" && (
          <BankAccountPage
            selectedBankId={selectedBankId}
            getBank={getBank}
            setScreen={navigate}
          />
        )}

        {screen === "aaMobile" && (
          <AAMobilePage
            selectedBankId={selectedBankId}
            getBank={getBank}

            aaMobile={aaMobile}
            setAaMobile={setAaMobile}
            aaMobileError={aaMobileError}
            setAaMobileError={setAaMobileError}

            openAaOtpSheet={openAaOtpSheet}
            setScreen={navigate}
          />
        )}

        {screen === "aaAccount" && (
          <AccountSelectionPage
            bankAccounts={bankAccounts}

            selectedAccountId={selectedAccountId}
            setSelectedAccountId={setSelectedAccountId}

            getBank={getBank}

            // openAddBankFromAa={openAddBankFromAa}

            setScreen={navigate}
          />
        )}

        {screen === "aaConsent" && (
          <ConsentPage
            selectedBankId={selectedBankId}
            getBank={getBank}

            setPaymentHistoryTab={setPaymentHistoryTab}
            setScreen={navigate}
          />
        )}

        {screen === "bankSuccess" && (
          <BankSuccessPage
            continueAfterBankSuccess={continueAfterBankSuccess}
          />
        )}

        {screen === "aadhaarKyc" && (
          <AadhaarVerificationPage
            mode="page"
            screen={screen}
            aadhaarNumber={aadhaarNumber}
            setAadhaarNumber={setAadhaarNumber}
            aadhaarError={aadhaarError}
            setAadhaarError={setAadhaarError}
            aadhaarStatus={aadhaarStatus}
            aadhaarProfile={aadhaarProfile}
            setAadhaarProfile={setAadhaarProfile}
            aadhaarConsent={aadhaarConsent}
            setAadhaarConsent={setAadhaarConsent}
            aadhaarSending={aadhaarSending}
            checkAadhaarOnEnter={checkAadhaarOnEnter}
            submitAadhaar={submitAadhaar}
            setAadhaarReferenceSecure={setAadhaarReferenceSecure}
            setScreen={navigate}
            sheet={sheet}
            closeSheet={closeSheet}
            aadhaarOtpDigits={aadhaarOtpDigits}
            aadhaarOtpRefs={aadhaarOtpRefs}
            handleAadhaarOtpChange={handleAadhaarOtpChange}
            handleAadhaarOtpKeyDown={handleAadhaarOtpKeyDown}
            aadhaarResendTimer={aadhaarResendTimer}
            resendAadhaarOtp={resendAadhaarOtp}
            aadhaarOtpError={aadhaarOtpError}
            verifyAadhaarOtp={verifyAadhaarOtp}
            aadhaarOtpVerifying={aadhaarOtpVerifying}
            formatAadhaarDisplay={formatAadhaarDisplay}
          />
        )}

        {screen === "referenceDetails" && (
          <ReferenceDetailsPage
            references={references}

            activeReferenceTab={activeReferenceTab}
            setActiveReferenceTab={
              setActiveReferenceTab
            }

            updateReference={updateReference}

            REFERENCE_RELATIONS={
              REFERENCE_RELATIONS
            }

            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}

            referenceError={referenceError}

            proceedReference={proceedReference}

            setReferenceError={setReferenceError}
            setScreen={navigate}
          />
        )}

        {screen === "referenceReview" && (
          <ReferenceReviewPage
            references={references}
            setScreen={navigate}
            confirmReferences={confirmReferences}
          />
        )}

        {screen === "selfieIntro" && (
          <SelfiePage
            setScreen={navigate}
            setSelfieFaceReady={setSelfieFaceReady}
            setSelfieError={setSelfieError}
            setSelfieHint={setSelfieHint}
          />
        )}

        {screen === "selfieCapture" && (
          <SelfieCapturePage
            selfieCameraRef={selfieCameraRef}

            selfieFaceReady={selfieFaceReady}
            setSelfieFaceReady={setSelfieFaceReady}

            selfieHint={selfieHint}
            setSelfieHint={setSelfieHint}

            selfieError={selfieError}
            setSelfieError={setSelfieError}

            selfiePhoto={selfiePhoto}
            setSelfiePhoto={setSelfiePhoto}

            leadSubmitting={leadSubmitting}

            persistSelfie={persistSelfie}
            saveEnquiryProgress={saveEnquiryProgress}

            submitLeadAndContinue={submitLeadAndContinue}

            setScreen={navigate}
          />
        )}

        {(screen === "leadSubmitting" ||
          screen === "leadSubmitFail") && (
            <LeadSubmissionPage
              screen={screen}
              leadSubmitError={leadSubmitError}
              leadSubmitting={leadSubmitting}
              submitLeadAndContinue={submitLeadAndContinue}
              setScreen={navigate}
            />
          )}

        {screen === "selfieSuccess" && (
          <SelfieSuccessPage
            setScreen={navigate}
          />
        )}

        {screen === "sectionLetter" && (
          <SectionLetterPage
            setScreen={navigate}
          />
        )}

        {screen === "disbursementProcessing" && (
          <DisbursementProcessingPage
            setScreen={navigate}
            loanAmount={employment.loanAmount}
            customerName={
              customerProfile?.name ||
              panProfile?.name ||
              aadhaarProfile?.name ||
              "Customer Name"
            }
          />
        )}

        {screen === "loanInProgress" && (
          <LoanInProgressPage
            setScreen={navigate}
            loanAmount={employment.loanAmount}
            customerName={
              customerProfile?.name ||
              panProfile?.name ||
              aadhaarProfile?.name ||
              "Customer Name"
            }
          />
        )}

        {screen === "activeLoanHome" && (
          <ActiveLoanHomePage
            setScreen={navigate}
            customerName={
              customerProfile?.name ||
              panProfile?.name ||
              aadhaarProfile?.name ||
              "Customer Name"
            }
            loanAmount={employment.loanAmount}
          />
        )}

        {screen === "repayment" && (
          <RepaymentPage
            setScreen={navigate}
            // loanAmount={employment.loanAmount}
             loanAmount={
      repaymentData?.remainingAmount > 0
        ? repaymentData.remainingAmount
        : employment.loanAmount
    }
              setRepaymentData={setRepaymentData}
          />
        )}

{screen === "demoPayment" && (
  <DemoPaymentPage
    setScreen={navigate}
    repaymentData={repaymentData}
  />
)}

{screen === "paymentSuccess" && (
  <PaymentSuccessPage
    setScreen={navigate}
    repaymentData={repaymentData}
    setRepaymentData={setRepaymentData}
  />
)}

        {screen === "hold" && (
          <HoldPage
            holdMessage={holdMessage}
          />
        )}

        {screen === "profile" && (
          <ProfilePage
            name={
              customerProfile?.name ||
              panProfile?.name ||
              aadhaarProfile?.name ||
              ""
            }

            email={
              customerProfile?.email ||
              email ||
              ""
            }

            mobile={
              customerProfile?.mobile ||
              mobile ||
              ""
            }

            avatarUrl={
              selfiePhoto ||
              customerProfile?.avatarUrl ||
              ""
            }

            loading={
              profileLoading &&
              !(
                customerProfile?.name ||
                panProfile?.name ||
                aadhaarProfile?.name
              )
            }

            onEdit={() => { }}

            onMenuClick={(id) => {
              if (id === "transactions") {
                setPaymentHistoryTab("transactions");
                navigate("/apply-new/paymentHistory");
              }

              if (id === "loans") {
                setPaymentHistoryTab("loans");
                navigate("/apply-new/paymentHistory");
              }

              if (id === "call") {
                window.location.href =
                  "tel:+918800846929";
              }

              if (id === "email") {
                window.location.href =
                  "mailto:info@fundswalle.com";
              }

              if (id === "about") {
                window.open(
                  "https://fundswalle.com/about-us",
                  "_blank",
                  "noopener,noreferrer"
                );
              }

              if (id === "terms") {
                window.open(
                  "https://sen/terms-conditions",
                  "_blank",
                  "noopener,noreferrer"
                );
              }

              if (id === "privacy") {
                window.open(
                  "https://fundswalle.com/privacy-policy",
                  "_blank",
                  "noopener,noreferrer"
                );
              }
            }}

            onTabChange={(tab) => {
              if (tab === "home") {
                navigate("/apply-new/activeLoanHome");
              }

              if (tab === "docs") {
                setPaymentHistoryTab("transactions");
                navigate("paymentHistory");
              }
            }}

            onLogout={() => {
              clearCustomerSession();
              setCustomerProfile(null);
              setMobile("");
              navigate("/apply-new/landing");
            }}
          />
        )}

        {screen === "paymentHistory" && (
          <PaymentHistoryPage
            activeTab={paymentHistoryTab}
            onTabChange={setPaymentHistoryTab}
            onNavChange={(tab) => {
              if (tab === "home") {
                navigate("/apply-new/");
              }

              if (tab === "profile") {
                navigate("/apply-new/profile");
              }
            }}
          />
        )}

        {sheet && (
          <div className={`fw-overlay ${sheetVisible ? "is-open" : ""}`}>
            <button type="button" className="fw-overlay__backdrop" aria-label="Close" onClick={closeSheet} />
            <div className={`fw-sheet ${sheetVisible ? "is-open" : ""}`}>

              <MobileVerificationPage
                sheet={sheet}
                mobile={mobile}
                setMobile={setMobile}
                consent={consent}
                setConsent={setConsent}
                mobileError={mobileError}
                setMobileError={setMobileError}
                otpSending={otpSending}
                sendOtp={sendOtp}
                otpDigits={otpDigits}
                otpRefs={otpRefs}
                handleOtpPaste={handleOtpPaste}
                handleOtpChange={handleOtpChange}
                handleOtpKeyDown={handleOtpKeyDown}
                resendTimer={resendTimer}
                otpError={otpError}
                openSheet={openSheet}
                otpVerifying={otpVerifying}
                otpValue={otpValue}
                verifyOtp={verifyOtp}
                formattedMobile={formatMobileDisplay(mobile)}
              />

              {sheet === "confirm" && panProfile && (
                <div className="fw-confirm">
                  <h2>Is this information correct?</h2>
                  <p className="fw-sheet__sub">Please match this with your PAN card.</p>

                  <div className="fw-pancard">
                    <div className="fw-pancard__head">
                      <div className="fw-pancard__org">
                        <small>आयकर विभाग</small>
                        <b>INCOME TAX DEPARTMENT</b>
                      </div>
                      <img className="fw-pancard__emblem" src={indiaEmblem} alt="" />
                      <div className="fw-pancard__govt">
                        <small>भारत सरकार</small>
                        <b>GOVT. OF INDIA</b>
                      </div>
                    </div>

                    <div className="fw-pancard__body">
                      <div className="fw-pancard__grid">
                        <p>
                          <span>Name</span>
                          <strong>{panProfile.name}</strong>
                        </p>
                        {/* <p>
                          <span>Father’s Name</span>
                          <strong>{panProfile.fatherName || "—"}</strong>
                        </p> */}
                        <p>
                          <span>Date of Birth</span>
                          <strong>{panProfile.dob}</strong>
                        </p>
                        <p>
                          <span>PAN Number</span>
                          <strong>{panProfile.pan}</strong>
                        </p>
                      </div>
                      {/* <div className="fw-pancard__sign">
                        <i>{(panProfile.name || "").split(" ")[0]}</i>
                        <span>Signature</span>
                      </div> */}
                    </div>
                  </div>

                  {/* <div className="fw-actions fw-actions--compact">
                    <button type="button" className="fw-btn fw-btn--ghost" onClick={closeSheet}>
                      No
                    </button>
                    <button type="button" className="fw-btn fw-btn--dark" onClick={confirmAndProceed}>
                      Confirm
                    </button>
                  </div> */}
                  {aadhaarDigiError && (
  <p className="fw-error">
    {aadhaarDigiError}
  </p>
)}

<div className="fw-actions fw-actions--compact">
  <button
    type="button"
    className="fw-btn fw-btn--ghost"
    onClick={closeSheet}
    disabled={aadhaarDigiLoading}
  >
    No
  </button>

  <button
    type="button"
    className="fw-btn fw-btn--dark"
    onClick={confirmAndProceed}
    disabled={aadhaarDigiLoading}
  >
    {aadhaarDigiLoading
      ? "Opening DigiLocker..."
      : "Confirm"}
  </button>
</div>
                </div>
              )}

              {/* {sheet === "aaOtp" && (
                <>
                  <h2>
                    OTP sent to <b>{formatMobileDisplay(aaMobile)}</b>
                  </h2>
                  <div className="fw-otp">
                    {aaOtpDigits.map((digit, index) => (
                      <input
                        key={`aa-${index}`}
                        ref={(el) => {
                          aaOtpRefs.current[index] = el;
                        }}
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        placeholder="0"
                        onChange={(e) => handleAaOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleAaOtpKeyDown(index, e)}
                      />
                    ))}
                  </div>
                  <p className="fw-resend">
                    Have not received your OTP?{" "}
                    {aaResendTimer > 0 ? (
                      <span>Resend in {aaResendTimer} seconds</span>
                    ) : (
                      <button
                        type="button"
                        onClick={() => {
                          setAaResendTimer(OTP_RESEND_SECONDS);
                          setAaOtpDigits(["", "", "", "", "", ""]);
                        }}
                      >
                        Resend OTP
                      </button>
                    )}
                  </p>
                  <p className="fw-legal">
                    By proceeding, you accept Fundswalle Terms &amp; Conditions. For support,
                    please contact Fundswalle.
                  </p>
                  {aaOtpError && <p className="fw-error">{aaOtpError}</p>}
                  <div className="fw-actions">
                    <button type="button" className="fw-btn fw-btn--ghost" onClick={closeSheet}>
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="fw-btn fw-btn--primary"
                      onClick={verifyAaOtp}
                      disabled={aaOtpValue.length !== 6}
                    >
                      Verify
                    </button>
                  </div>
                </>
              )} */}
              {sheet === "aaOtp" && (
                <AAOtpPage
                  aaMobile={aaMobile}

                  aaOtpDigits={aaOtpDigits}
                  aaOtpRefs={aaOtpRefs}

                  handleAaOtpChange={handleAaOtpChange}
                  handleAaOtpKeyDown={handleAaOtpKeyDown}

                  aaResendTimer={aaResendTimer}

                  aaOtpError={aaOtpError}

                  verifyAaOtp={verifyAaOtp}
                  closeSheet={closeSheet}

                  aaOtpValue={aaOtpValue}
                  formatMobileDisplay={formatMobileDisplay}

                  OTP_RESEND_SECONDS={OTP_RESEND_SECONDS}
                  setAaResendTimer={setAaResendTimer}
                  setAaOtpDigits={setAaOtpDigits}
                />
              )}

              {/* {sheet === "aadhaarOtp" && (
                <>
                  <h2>Enter Aadhaar OTP</h2>
                  <p className="fw-sheet__sub">
                    OTP sent to the mobile number linked with Aadhaar{" "}
                    <b>{formatAadhaarDisplay(aadhaarNumber)}</b>
                  </p>
                  <div className="fw-otp">
                    {aadhaarOtpDigits.map((digit, index) => (
                      <input
                        key={`aadhaar-otp-${index}`}
                        ref={(el) => {
                          aadhaarOtpRefs.current[index] = el;
                        }}
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        placeholder="0"
                        onChange={(e) => handleAadhaarOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleAadhaarOtpKeyDown(index, e)}
                      />
                    ))}
                  </div>
                  <p className="fw-resend">
                    Have not received your OTP?{" "}
                    {aadhaarResendTimer > 0 ? (
                      <span>Resend in {aadhaarResendTimer} seconds</span>
                    ) : (
                      <button
                        type="button"
                        onClick={resendAadhaarOtp}
                        disabled={aadhaarSending}
                      >
                        {aadhaarSending ? "Sending..." : "Resend OTP"}
                      </button>
                    )}
                  </p>
                  {aadhaarOtpError && <p className="fw-error">{aadhaarOtpError}</p>}
                  <div className="fw-actions">
                    <button type="button" className="fw-btn fw-btn--ghost" onClick={closeSheet}>
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="fw-btn fw-btn--primary"
                      onClick={verifyAadhaarOtp}
                      disabled={aadhaarOtpVerifying || aadhaarOtpDigits.join("").length !== 6}
                    >
                      {aadhaarOtpVerifying ? "Verifying..." : "Verify"}
                    </button>
                  </div>
                </>
              )} */}'

              {sheet === "aadhaarOtp" && (
                <AadhaarVerificationPage
                  mode="otp"
                  sheet={sheet}

                  aadhaarNumber={aadhaarNumber}

                  aadhaarOtpDigits={aadhaarOtpDigits}
                  aadhaarOtpRefs={aadhaarOtpRefs}

                  handleAadhaarOtpChange={handleAadhaarOtpChange}
                  handleAadhaarOtpKeyDown={handleAadhaarOtpKeyDown}

                  aadhaarResendTimer={aadhaarResendTimer}
                  resendAadhaarOtp={resendAadhaarOtp}

                  aadhaarOtpError={aadhaarOtpError}

                  verifyAadhaarOtp={verifyAadhaarOtp}
                  aadhaarOtpVerifying={aadhaarOtpVerifying}

                  closeSheet={closeSheet}

                  aadhaarSending={aadhaarSending}

                  formatAadhaarDisplay={formatAadhaarDisplay}
                />
              )}

              {/* {sheet === "aadhaarOtp" && (
  <AadhaarVerificationPage
    mode="otp"
    aadhaarNumber={aadhaarNumber}
    aadhaarOtpDigits={aadhaarOtpDigits}
    aadhaarOtpRefs={aadhaarOtpRefs}
    handleAadhaarOtpChange={handleAadhaarOtpChange}
    handleAadhaarOtpKeyDown={handleAadhaarOtpKeyDown}
    aadhaarResendTimer={aadhaarResendTimer}
    resendAadhaarOtp={resendAadhaarOtp}
    aadhaarOtpError={aadhaarOtpError}
    verifyAadhaarOtp={verifyAadhaarOtp}
    aadhaarOtpVerifying={aadhaarOtpVerifying}
    closeSheet={closeSheet}
    aadhaarSending={aadhaarSending}
    formatAadhaarDisplay={formatAadhaarDisplay}
  />
)} */}

            </div>
          </div>
        )}

        <RejectModal
          showRejectModal={showRejectModal}
          rejectMessage={rejectMessage}
          setShowRejectModal={setShowRejectModal}
        />
      </div>
    </div>
  );
};

export default ApplyNewFlow;